import React, { useState, useEffect, useRef } from "react";
import { ArrowLeft, LeftAnkle, Info, Copy, Wallet, Shield, Plus, ShoppingCart, Minus, CreditCard, FileText, Lock, Users, Building, TrendingUp, Calendar, Bell, User, Settings, QrCode, CheckCircle, Hospital, FlaskConical, Pill, Stethoscope, Eye, ChevronRight, Ambulance, BookDashed, BoldIcon, Phone, Banknote, Baby, Group } from "lucide-react";
import { useNavigate } from "react-router-dom";
import BottomNavigation from "../components/bottom_navigation";
import FeatureHeader from "../components/FeatureHeader";
import Card from "../components/Card";
import Button from "../components/Button";
import Services, { providersAPI, walletAPI } from "../lib/services";
import api from "../lib/api";
import { Html5Qrcode } from "html5-qrcode";
import defence from "../assets/icons/defence.png"
import { useStripe, useElements, CardElement, loadStripe } from "@stripe/react-stripe-js";


import hospital from "../assets/icons/hospital.png"
import health from "../assets/icons/health-insurance.png"
import fridge from "../assets/icons/fridge.png"
import payment from "../assets/icons/payment-method.png"
import pay from "../assets/icons/pay.png"
import withdraw from "../assets/icons/withdraw.png"
import nine from "../assets/icons/9.png"
import man from "../assets/icons/man.png"
import boy from "../assets/icons/boy.png"
import parents from "../assets/icons/parents.png"
import purse from "../assets/icons/purse.png"
import confirmation from "../assets/icons/confirmation.png"
import pharmacy from "../assets/icons/pharmacy.png"
import stethoscope from "../assets/icons/stethoscope.png"
import claim from "../assets/icons/claim.png"
import fam from "../assets/icons/fam.png"

import microscope from "../assets/icons/microscope.png"
import hos from "../assets/icons/hos.png"

const userId = localStorage.getItem('userId') 

const SERVICE_TYPE_ALIASES = {
  medicine: 'medicine_refill',
  follow_up: 'consultation',
};



const trustHighlights = [
  {
    icon: <Shield color="var(--primary)" size={22} strokeWidth={2} />, // outline style
    title: "Secure & Regulated",
    subtitle: "Your funds are safe",
  },
  {
    icon: <Lock color="var(--primary)" size={22} strokeWidth={2} />, // outline style
    title: "Healthcare Only",
    subtitle: "Approved medical use",
  },
  {
    icon: <Users color="var(--primary)" size={22} strokeWidth={2} />, // outline style
    title: "Family Support",
    subtitle: "You and your loved ones",
  },
];

export default function HealthWalletApp() {



  const trustStripRef = useRef(null);
  const hasLoadedDependentsRef = useRef(false);
  const [isTrustStripPaused, setIsTrustStripPaused] = useState(false);

  // Auto-scroll effect for trust strip (infinite loop, pause on hover/touch)
  useEffect(() => {
    const strip = trustStripRef.current;
    if (!strip || isTrustStripPaused) return;
    const interval = setInterval(() => {
      const resetPoint = strip.scrollWidth / 2;
      if (resetPoint <= 0) return;
      if (strip.scrollLeft >= resetPoint) {
        strip.scrollLeft -= resetPoint;
      }
      strip.scrollBy({ left: 1, behavior: 'auto' });
    }, 24);
    return () => clearInterval(interval);
  }, [isTrustStripPaused]);

  const [activeScreen, setActiveScreen] = useState("Dashboard");
  const [walletBalance, setWalletBalance] = useState(0);
  const [customAmount, setCustomAmount] = useState("");
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [benefits, setBenefits] = useState([]);
 
  const [insurancePlans, setInsurancePlans] = useState([]);
  const [providers, setProviders]= useState(null)
  const [insuranceSubscription, setInsuranceSubscription] = useState(null);
  const [insuranceClaims, setInsuranceClaims] = useState([]);
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const [walletAlerts, setWalletAlerts] = useState(null);
  const [coverageEstimate, setCoverageEstimate] = useState(null);
  const [dependents, setDependents] = useState([]);
  const [supportAllocations, setSupportAllocations] = useState([]);
  const [walletSummary, setWalletSummary] = useState(null);
  const [insuranceReminders, setInsuranceReminders] = useState([]);
  const [subscriptionUpdateNotice, setSubscriptionUpdateNotice] = useState(null);

  const navigate = useNavigate();




  // Fetch initial data
  useEffect(() => {
    fetchDashboardData();
  }, []);


  useEffect(() => {
        const fetchDashboardData = async () => {

    try {
        setIsLoading(true);
        const balanceRes = await api.post('/api/wallet/balance', { params: { user: localStorage.getItem('userId') } });
        console.log('Wallet balance response:', balanceRes);
        if (balanceRes.data && typeof balanceRes.data.balance !== 'undefined') {
            setWalletBalance(balanceRes.data.balance);


        }
    } catch (error) {
        console.error('Error fetching wallet balance:', error);
        }
    }
    fetchDashboardData();
  }, []);

  useEffect(() => {
    if (!subscriptionUpdateNotice?.message) return;

    const timerId = setTimeout(() => {
      setSubscriptionUpdateNotice(null);
    }, 3500);

    return () => clearTimeout(timerId);
  }, [subscriptionUpdateNotice]);


  const fetchDashboardData = async () => {
  try {
    setIsLoading(true);

    // Fetch wallet balance
    const balanceRes = await Services.wallet.getBalance();
    console.log('Wallet balance response:', balanceRes);
    if (balanceRes.balance && typeof balanceRes.balance !== 'undefined') {
      setWalletBalance(balanceRes.balance);
      console.log('Updated wallet balance:', balanceRes.balance);
    }

    // Fetch recent transactions
    const transactionsRes = await Services.wallet.getTransactions({ limit: 5 });
     console.log('Transactions response:', transactionsRes);
    if (transactionsRes.transactions) {
        console.log('Transactions response:', transactionsRes);
      setTransactions(transactionsRes.transactions || []);
    }

    // Fetch insurance plans
    const plansRes = await Services.insurance.getPlans();
    if (plansRes.data) {
      setInsurancePlans(plansRes.data.plans || []);
    }

    // Fetch insurance subscription
    try {
      const subscriptionRes = await Services.insurance.getSubscription();
      if (subscriptionRes.data) {
        setInsuranceSubscription(subscriptionRes.data.subscription || null);
      }
    } catch (error) {
      // No subscription found - this is okay
      console.log('No active subscription:', error.message);
    }

    // Fetch insurance renewal reminders
    try {
      const remindersRes = await Services.insurance.getSubscriptionReminders();
      setInsuranceReminders(Array.isArray(remindersRes?.reminders) ? remindersRes.reminders : []);
    } catch (error) {
      console.log('Insurance reminders unavailable:', error.message);
    }

    // Fetch benefits
    const benefitsRes = await Services.benefits.getAll();
    if (benefitsRes.data) {
      setBenefits(benefitsRes.data.benefits || []);
    }

    // Fetch providers
    const providersRes = await Services.providers.getAll({ limit: 10 });
    if (providersRes.data) {
      setProviders(providersRes.data.providers || []);
    }

    // Fetch insurance claims
    try {
      const claimsRes = await Services.insurance.getClaims({ limit: 3 });
      if (claimsRes.data) {
        setInsuranceClaims(claimsRes.data.claims || []);
      }
    } catch (error) {
      console.log('No claims found:', error.message);
    }

    // Fetch health-wallet alerts, coverage estimate, dependents, and summary
    try {
      const [alertsRes, estimateRes, dependentsRes, summaryRes, fundingContextRes] = await Promise.all([
        Services.wallet.getWalletAlerts(),
        Services.wallet.getCoverageEstimate(),
        Services.wallet.getDependents(),
        Services.wallet.getWalletSummary(),
        Services.wallet.getFundingContext(),
      ]);

      setWalletAlerts(alertsRes?.alerts || null);
      setCoverageEstimate(estimateRes?.estimate || null);
      setDependents(Array.isArray(dependentsRes?.dependents) ? dependentsRes.dependents : []);
      setSupportAllocations(Array.isArray(fundingContextRes?.context?.supportAllocations) ? fundingContextRes.context.supportAllocations : []);
      hasLoadedDependentsRef.current = true;
      setWalletSummary(summaryRes?.summary || null);
    } catch (error) {
      console.log('Wallet extended insights unavailable:', error.message);
    }

  } catch (error) {
    console.error('Error fetching dashboard data:', error);
   
  } finally {
    setIsLoading(false);
  }
};
  // ------------------ Common Components ------------------
  const Header = ({ title, showBack = true }) => (
    <div style={{ display: "flex", alignItems: "center", marginBottom: "24px", padding: "8px 0" }}>
    </div>
  );

const TransactionItem = ({ item }) => {
  const careSummary = getCareSummary(item); // e.g. "Lab test • Completed • Apr 20"
  const careStatus = getCareStatus(item);
  console.log(item.type)

  const startDate = new Date(item.createdAt).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });

  const endDate = startDate; // adjust if you later support ranges

  const amountText =
    item.type === "insurance_payment" ? "Free" : `-$${item.amount.toFixed(2)}`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "8px 10px",
        borderRadius: 10,
        background: "#F8F7FB",
        marginBottom: 6,
      }}
    >
      {/* Transaction item content here, e.g. icon, summary, amount, etc. */}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 12 }}>{careSummary}</div>
        <div style={{ fontSize: 10, color: "#6B6781" }}>{startDate}</div>
      </div>
      <div style={{ fontWeight: 700, fontSize: 12, color: item.type === "insurance_payment" ? "#0D9B59" : "#1f1d34" }}>
        {amountText}
      </div>
    </div>
  );
};



  const QuickAction = ({ icon: Icon, label, color, onClick, loading = false }) => (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
      cursor: loading ? "not-allowed" : "pointer",
      padding: "12px",
      borderRadius: "16px",
      transition: "all 0.2s ease",
      opacity: loading ? 0.7 : 1,
      // Remove hover background for icon, keep for card
      ":hover": loading ? {} : {
        background: "rgba(255,255,255,0.5)",
        transform: "translateY(-2px)"
      }
    }} onClick={loading ? undefined : onClick}>
      <div style={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: color || "#ede9fe",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(124,77,255,0.06)",
        marginBottom: 4,
      }}>
        <Icon size={28} color="#fff" />
      </div>
      <div style={{ fontSize: "0.85rem", fontWeight: 600, color: "#2D3436", textAlign: "center" }}>
        {loading ? "Loading..." : label}
      </div>
    </div>
  );

  // Helper functions

  const getCareSummary = (item) => {
  const date = new Date(item.createdAt).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });

  let careType = "Medical service";

  switch (item.type) {
    case "lab_payment":
      careType = "Lab test";
      break;
    case "pharmacy_payment":
      careType = "Pharmacy order";
      break;
    case "payment":
      careType = "Doctor visit";
      break;
    case "insurance_payment":
      careType = "Doctor visit";
      break;
    default:
      break;
  }

  let careState = "Completed";

  if (item.type === "insurance_payment") {
    careState = "Covered";
  } else if (item.status === "pending") {
    careState = "Pending results";
  }

  return `${careType} • ${careState} • ${date}`;
};


  const getTransactionColor = (type) => {
  switch (type) {
    case "lab_payment":
      return "#EEF2FF"; // calm purple
    case "pharmacy_payment":
      return "#ECFDF5"; // medical green
    case "payment":
      return "#EFF6FF"; // consultation blue
    case "insurance_payment":
      return "#ECFDF5"; // covered green
    default:
      return "#F3F4F6";
  }
};


  const getTransactionIcon = (type) => {
  switch (type) {
    case "lab-test":
      return <FlaskConical size={22} color="#6D5EF6" />;

    case "drugs":
      return <Pill size={22} color="#6D5EF6" />;

    case "consultation":
      return <Stethoscope size={22} color="#6D5EF6" />;

    case "insurance_payment":
      return <Shield size={22} color="#047857" />;

    default:
      return <Hospital size={22} color="#6B7280" />;
  }
};


  // ------------------ Services Functions ------------------
  const handleDeposit = async (amount, paymentMethod = "wallet") => {
    try {
      setIsLoading(true);
      const response = await Services.wallet.deposit({
        amount: parseFloat(amount),
        paymentMethod
      });

      if (response.success) {
        setWalletBalance(response.newBalance);
        alert(`Successfully added $${amount} to your wallet!`);
        setCustomAmount("");
        await fetchDashboardData();
      }
    } catch (error) {
      alert(error.error || "Deposit failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleWithdraw = async (amount, withdrawalMethod = "bank_transfer") => {
    try {
      setIsLoading(true);
      const response = await Services.wallet.withdraw({
        amount: parseFloat(amount),
        withdrawalMethod
      });

      if (response.success) {
        setWalletBalance(response.newBalance);
        alert("Withdrawal Successful! Funds will be available within 24 hours.");
        await fetchDashboardData();
      }
    } catch (error) {
      alert(error.error || "Withdrawal failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  

  const handleInsuranceSubscribe = async (planId, paymentMethod = "wallet") => {
    try {
      setIsLoading(true);
      const response = await Services.insurance.subscribe({
        planId,
        paymentMethod
      });

      if (response.success) {
        setInsuranceSubscription(response.subscription);
        setWalletBalance(response.newBalance);
        alert("Insurance subscription activated successfully!");
        await fetchDashboardData();
      }
    } catch (error) {
        console.log(error)
      alert(error || "Subscription failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      setIsLoading(true);
      const response = await Services.insurance.cancelSubscription();

      if (response.success) {
        setInsuranceSubscription(null);
        alert("Subscription cancelled successfully!");
        await fetchDashboardData();
      }
    } catch (error) {
      alert(error.error || "Failed to cancel subscription.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateSubscriptionSettings = async (settings) => {
    try {
      setIsLoading(true);
      setSubscriptionUpdateNotice(null);
      const response = await Services.insurance.updateSubscription(settings);

      if (response?.success) {
        setInsuranceSubscription(response.subscription || null);
        if (typeof settings.autoRenew === "boolean") {
          setSubscriptionUpdateNotice({
            type: "success",
            message: settings.autoRenew
              ? "Auto-renew enabled successfully."
              : "Auto-renew turned off. You will need to renew manually.",
          });
        } else {
          setSubscriptionUpdateNotice({ type: "success", message: "Subscription settings updated." });
        }
        await fetchDashboardData();
      }
    } catch (error) {
      setSubscriptionUpdateNotice({
        type: "error",
        message: error?.response?.data?.error || error?.message || "Failed to update subscription settings.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitClaim = async (claimData) => {
    try {
      setIsLoading(true);
      const response = await Services.insurance.submitClaim(claimData);

      if (response.success) {
        alert("Claim submitted successfully! It will be reviewed within 3-5 business days.");
        await fetchDashboardData();

        // Log activity
        try {
          await api.post('/api/activities/add-activity', { message: 'Submitted an insurance claim' });
        } catch (err) {
          console.error('Failed to log insurance claim activity', err);
        }
      }
    } catch (error) {
      alert(error.error || "Failed to submit claim.");
    } finally {
      setIsLoading(false);
    }
  };

  const resolveReservedAmount = (candidateKeys = []) => {
    const funds = walletSummary?.reservedFunds || {};
    for (const key of candidateKeys) {
      const value = Number(funds?.[key] || 0);
      if (Number.isFinite(value) && value > 0) {
        return value;
      }
    }
    return 0;
  };

  const familyDedicatedAmount = resolveReservedAmount([
    'familySupport',
    'dependents',
    'family',
    'family_wallet',
    'dependent_allowance',
  ]);

  const employerUploadedAmount = resolveReservedAmount([
    'employer',
    'employer_wallet',
    'employer_support',
    'company',
  ]);

  const healthFundsCards = [
    {
      key: 'my',
      title: 'My Wallet',
      subtitle: 'For your personal care',
      amount: Number(walletBalance || 0),
      helper: 'Available Balance',
      iconBg: '#6A4DF6',
      icon: <User size={18} color="#fff" />,
      accent: '#6A4DF6',
      progress: 0.62,
      badge: 'Primary',
      badgeBg: '#E8FFF2',
      badgeColor: '#0D9B59',
    },
    {
      key: 'family',
      title: 'Family Wallet',
      subtitle: 'For your dependents',
      amount: familyDedicatedAmount,
      helper: 'Dedicated Amount',
      iconBg: '#F59E0B',
      icon: <Users size={18} color="#fff" />,
      accent: '#F59E0B',
      progress: 0.58,
    },
    {
      key: 'employer',
      title: 'Employer Wallet',
      subtitle: 'Company health benefit',
      amount: employerUploadedAmount,
      helper: 'Uploaded by Employer',
      iconBg: '#16A34A',
      icon: <Building size={18} color="#fff" />,
      accent: '#16A34A',
      progress: 0.46,
    },
  ];

  const getDependentAllocation = (dependentId) =>
    supportAllocations.find((allocation) => String(allocation.dependentId) === String(dependentId));

  const primaryDependent = dependents[0] || null;
  const primaryDependentAllocation = primaryDependent ? getDependentAllocation(primaryDependent._id || primaryDependent.id) : null;
  const dependentBalance = Number(
    primaryDependent?.balance ??
    primaryDependent?.availableBalance ??
    primaryDependentAllocation?.availableAmount ??
    primaryDependentAllocation?.remainingAmount ??
    0
  );
  const dependentMonthlyLimit = Number(
    primaryDependent?.monthlyLimit ??
    primaryDependent?.allowanceAmount ??
    primaryDependentAllocation?.availableAmount ??
    primaryDependentAllocation?.amount ??
    0
  );
  const dependentUsedThisMonth = Number(
    primaryDependent?.usedThisMonth ??
    primaryDependent?.spentThisMonth ??
    primaryDependentAllocation?.usedAmount ??
    (dependentMonthlyLimit > 0 ? Math.max(0, dependentMonthlyLimit - dependentBalance) : 0)
  );
  const dependentUsageRatio = dependentMonthlyLimit > 0 ? Math.min(1, dependentUsedThisMonth / dependentMonthlyLimit) : 0;
  const dependentTypeLabel = String(primaryDependent?.relationship || 'Dependent')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
  const primaryInsurancePlan = insuranceSubscription?.plan || insurancePlans?.[0] || null;
  const rawPlanPrice = Number(
    primaryInsurancePlan?.price ??
    primaryInsurancePlan?.premium ??
    primaryInsurancePlan?.amount ??
    primaryInsurancePlan?.monthlyPremium ??
    0
  );
  const microinsuranceDailyPrice = rawPlanPrice > 0 ? rawPlanPrice / 30 : 0.1;

  // ------------------ DASHBOARD ------------------
const Dashboard = () => (
  <div className="container">

    {/* ================= HEADER ================= */}
    <div style={styles.header}>
      <FeatureHeader
        title="Health Wallet"
        subtitle="Your healthcare funds, protected and ready"
        onBack={() => navigate(-1)}
        containerStyle={{ padding: 0 }}
      />

      {/* Horizontally scrolling trust strip (like epharmacy/doctor) 
      <div
        ref={trustStripRef}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 6,
          margin: "12px 0 10px 0",
          background: "#ffffff",
          border: "1px solid #eceef1",
          borderRadius: 999,
          padding: "6px 8px",
          overflowX: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          maxWidth: 600,
        }}
        className="wallet-trust-strip-scroll"
        onMouseEnter={() => setIsTrustStripPaused(true)}
        onMouseLeave={() => setIsTrustStripPaused(false)}
        onTouchStart={() => setIsTrustStripPaused(true)}
        onTouchEnd={() => setIsTrustStripPaused(false)}
      >
       
        <div style={{ display: "flex", alignItems: "center", width: "max-content", gap: 6 }}>
          {[...trustHighlights, ...trustHighlights].map((item, idx, arr) => (
            <React.Fragment key={idx}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 142 }}>
                <div style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  border: "1px solid #eceef1",
                  background: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}><div style={{width : 15, height : 15, display: "flex", justifyContent : "center", alignItems : "center" }}>{item.icon}</div></div>
                <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}>
                  <span style={{ fontSize: 11, color: "#3D3A52", fontWeight: 700, whiteSpace: "nowrap" }}>{item.title}</span>
                  <span style={{ fontSize: 9, color: "#A0A0B2", fontWeight: 500, whiteSpace: "nowrap" }}>{item.subtitle}</span>
                </div>
              </div>
              {idx < arr.length - 1 && <div style={{ width: 1, height: 20, background: "#d6d2e7", flexShrink: 0 }} />}
            </React.Fragment>
          ))}
        </div>
    
        <style>{`
          .wallet-trust-strip-scroll::-webkit-scrollbar { display: none; }
          .wallet-trust-strip-scroll { scrollbar-width: none; -ms-overflow-style: none; }
        `}</style>
      </div>
      */}
    </div>

    {/* ================= COVERAGE + CARE FUNDS (SEPARATE PAGES) ================= */}

    {activeScreen === "Dashboard" && (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: 0, marginBottom: 12, width: "100%",  }}>
          {/* Coverage Status Card */}
   

          {/* Available Care Funds Card (EXACT MATCH TO SCREENSHOT) */}
          <Card
            style={{
              width: "100%",
 
              borderRadius: 16,
              background: "var(--primary)",
              color: "#fff",
              boxShadow: "0 2px 12px rgba(106,77,246,0.13)",
              padding: 14,
              border: "none",
              marginTop: 10,
              marginBottom: 12,
              position: "relative",
              overflow: "hidden",
              minWidth: 200,
              fontFamily: 'Inter, Arial, sans-serif',
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontWeight: 700, fontSize: 14, fontFamily: 'Inter, Arial, sans-serif', letterSpacing: 0.2, lineHeight: 1.1 }}>Available care funds</div>
              <div style={{ width: 22, height: 22, borderRadius: "50%", background: "rgba(255,255,255,0.13)", display: "grid", placeItems: "center" }}>
                <Eye size={14} color="#fff" />
              </div>
            </div>
            <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.7px", lineHeight: 1, marginBottom: 8 }}>
              ${walletBalance.toLocaleString(undefined, { minimumFractionDigits: 1 })}
            </div>
            <div style={{ fontSize: 12, opacity: 0.97, marginBottom: 10, fontWeight: 500 }}>
              Reserved for approved healthcare services
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <button
                onClick={() => setActiveScreen("AddMoney")}
                style={{
                  background: "#fff",
                  color: "#6A4DF6",
                  fontWeight: 700,
                  flex: 1,
                  borderRadius: 10,
                  border: "none",
                  fontSize: 13,
                  padding: "10px 0",
                  boxShadow: "0 1px 2px rgba(106,77,246,0.07)",
                  transition: "box-shadow 0.2s",
                }}
              >
                + Add Funds
              </button>
              <button
                onClick={() => setActiveScreen("PayProvider")}
                style={{
                  background: "rgba(255,255,255,0.13)",
                  color: "#fff",
                  fontWeight: 700,
                  flex: 1,
                  borderRadius: 10,
                  border: "1px solid rgba(255,255,255,0.35)",
                  fontSize: 13,
                  padding: "10px 0",
                  boxShadow: "0 1px 2px rgba(106,77,246,0.07)",
                  transition: "box-shadow 0.2s",
                }}
              >
                Use for Care
              </button>
            </div>
            <div
              onClick={() => setActiveScreen("ExternalTopup")}
              style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, cursor: "pointer", color: "#fff", opacity: 0.93, marginTop: 2 }}
            >
              <img src={fam} style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} alt="family" /> Support a Family Member
              <ChevronRight size={14} />
            </div>
            <div
              onClick={() => setActiveScreen("ManageDependents")}
              style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, cursor: "pointer", color: "#fff", opacity: 0.93, marginTop: 8 }}
            >
              <Users size={15} /> Manage Dependents
              <ChevronRight size={14} />
            </div>
          </Card>

          <Card
            style={{
              width: "100%",
              borderRadius: 14,
              border: "1px solid #eceaf3",
              padding: "10px 6px",
              marginTop: 2,
              marginBottom: 10,
              background: "#fff",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
                gap: 4,
                alignItems: "start",
              }}
            >
              {[
                {
                  label: "Shop",
                  icon: <ShoppingCart size={16} color="var(--primary)" strokeWidth={2} />,
                  onClick: () => navigate("/epharmacy"),
                },
                {
                  label: "Consultation",
                  icon: <Stethoscope size={16} color="var(--primary)" strokeWidth={2} />,
                  onClick: () => navigate("/doctor-consult"),
                },
                {
                  label: "Pay for Care",
                  icon: <Wallet size={16} color="var(--primary)" strokeWidth={2} />,
                  onClick: () => setActiveScreen("PayProvider"),
                },
                {
                  label: "Lab-test",
                  icon: <FlaskConical size={16} color="var(--primary)" strokeWidth={2} />,
                  onClick: () => navigate("/lab-tests"),
                },
                {
                  label: "Cards & Plans",
                  icon: <CreditCard size={16} color="var(--primary)" strokeWidth={2} />,
                  onClick: () => setActiveScreen("ManagePlan"),
                },
              ].map((item) => (
                <button
                  key={item.label}
                  onClick={item.onClick}
                  style={{
                    border: "none",
                    background: "transparent",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: 6,
                    padding: "6px 2px",
                    borderRadius: 10,
                    cursor: "pointer",
                    minHeight: 64,
                  }}
                >
                  <span
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      display: "grid",
                      placeItems: "center",
                      background: "#f5f3ff",
                    }}
                  >
                    {item.icon}
                  </span>
                  <span
                    style={{
                      fontSize: 9,
                      fontWeight: 600,
                      color: "#2f2b46",
                      lineHeight: 1.2,
                      textAlign: "center",
                    }}
                  >
                    {item.label}
                  </span>
                </button>
              ))}
            </div>
          </Card>

          <Card
            style={{
              width: '100%',
              borderRadius: 14,
              border: '1px solid #eceaf3',
              padding: 12,
              marginTop: 2,
              marginBottom: 10,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: '#1f1d34' }}>My Health Funds</div>
              <button
                type="button"
                onClick={() => setActiveScreen('ManageDependents')}
                style={{
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--primary)',
                  fontWeight: 700,
                  fontSize: 13,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  cursor: 'pointer',
                }}
              >
                View All <ChevronRight size={14} />
              </button>
            </div>

            <div
              style={{
                
                gap: 10,
              }}
            >
              {healthFundsCards.map((card) => (
                <div
                  key={card.key}
                  style={{
                    border: '1px solid #eceaf3',
                    borderRadius: 14,
                    padding: 12,
                    background: '#fff',
                    width : "100%",

                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          background: card.iconBg,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        {card.icon}
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14, color: '#1f1d34', lineHeight: 1.2 }}>{card.title}</div>
                        <div style={{ fontSize: 11.5, color: '#6B6781', marginTop: 2 }}>{card.subtitle}</div>
                      </div>
                    </div>
                    {card.badge ? (
                      <span
                        style={{
                          fontSize: 10,
                          fontWeight: 700,
                          padding: '4px 8px',
                          borderRadius: 999,
                          background: card.badgeBg,
                          color: card.badgeColor,
                        }}
                      >
                        {card.badge}
                      </span>
                    ) : null}
                  </div>

                  <div style={{ fontWeight: 800, fontSize: 21, color: '#1f1d34', marginBottom: 3 }}>
                    ${Number(card.amount || 0).toFixed(2)}
                  </div>
                  <div style={{ fontSize: 12, color: '#6B6781', marginBottom: 10 }}>{card.helper}</div>

                  <div
                    style={{
                      height: 6,
                      width: '100%',
                      borderRadius: 999,
                      background: '#F0EEF7',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${Math.max(0.1, Math.min(1, card.progress)) * 100}%`,
                        background: card.accent,
                        borderRadius: 999,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card
            style={{
              width: '100%',
              borderRadius: 14,
              border: '1px solid #eceaf3',
              padding: 12,
              marginTop: 2,
              marginBottom: 10,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <div style={{ fontWeight: 800, fontSize: 15, color: '#1f1d34' }}>Manage Dependents</div>
              <button
                type="button"
                onClick={() => setActiveScreen('ManageDependents')}
                style={{
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--primary)',
                  fontWeight: 700,
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                Manage All
              </button>
            </div>

            {primaryDependent ? (
              <div
                style={{
                  border: '1px solid #eceaf3',
                  borderRadius: 16,
                  padding: 14,
                  background: '#fff',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                    <div
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: '#F1ECFF',
                        color: 'var(--primary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 800,
                        fontSize: 18,
                        flexShrink: 0,
                      }}
                    >
                      {String(primaryDependent?.fullName || primaryDependent?.name || 'D')
                        .split(' ')
                        .map((part) => part[0])
                        .join('')
                        .slice(0, 2)
                        .toUpperCase()}
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <div style={{ fontWeight: 700, fontSize: 14, color: '#1f1d34' }}>
                          {primaryDependent?.fullName || primaryDependent?.name || 'Dependent'}
                        </div>
                        <span
                          style={{
                            fontSize: 10,
                            fontWeight: 700,
                            padding: '4px 8px',
                            borderRadius: 999,
                            background: '#F1ECFF',
                            color: 'var(--primary)',
                          }}
                        >
                          {dependentTypeLabel}
                        </span>
                      </div>
                      <div style={{ fontSize: 11.5, color: '#6B6781', marginTop: 2 }}>Dependent</div>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={() => setActiveScreen('ManageDependents')}
                    style={{
                      border: 'none',
                      borderRadius: 999,
                      padding: '10px 14px',
                      background: '#F4EEFF',
                      color: 'var(--primary)',
                      fontWeight: 700,
                      fontSize: 12,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      cursor: 'pointer',
                      flexShrink: 0,
                    }}
                  >
                    View Details <ChevronRight size={14} />
                  </button>
                </div>

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                    gap: 10,
                    marginTop: 14,
                    alignItems: 'end',
                  }}
                >
                  <div>
                    <div style={{ fontSize: 11, color: '#6B6781', marginBottom: 4 }}>Balance</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#1f1d34' }}>${dependentBalance.toFixed(2)}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #EFEAF8', paddingLeft: 10 }}>
                    <div style={{ fontSize: 11, color: '#6B6781', marginBottom: 4 }}>Monthly Limit</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#1f1d34' }}>${dependentMonthlyLimit.toFixed(2)}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #EFEAF8', paddingLeft: 10 }}>
                    <div style={{ fontSize: 11, color: '#6B6781', marginBottom: 4 }}>Used This Month</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#16A34A' }}>
                      ${dependentUsedThisMonth.toFixed(2)}
                      <span style={{ fontSize: 12, color: '#6B6781', fontWeight: 600 }}> / ${dependentMonthlyLimit.toFixed(2)}</span>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: 10,
                    height: 6,
                    width: '100%',
                    borderRadius: 999,
                    background: '#F0EEF7',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      height: '100%',
                      width: `${Math.max(0.08, dependentUsageRatio) * 100}%`,
                      background: '#16A34A',
                      borderRadius: 999,
                    }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ background: '#F8F7FB', borderRadius: 12, padding: 14, color: '#6B6781', fontSize: 12.5 }}>
                No dependents added yet. Add one to create family care allowances and track monthly usage.
              </div>
            )}
          </Card>

<Card
  style={{
    borderRadius: 20,
    padding: 16,
    border: '1px solid #E8E1FB',
    background: '#F7F4FF',
    overflow: 'hidden',
  }}
>
  {/* Top */}
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 12,
    }}
  >
    <div
      style={{
        width: 60,
        height: 60,
        borderRadius: 16,
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Shield size={34} color="var(--primary)" />
    </div>

    <div style={{ flex: 1 }}>
      <h4
        style={{
          margin: 0,
          fontSize: 18,
          fontWeight: 800,
        }}
      >
        Microinsurance
      </h4>

      <p
        style={{
          margin: '4px 0 0',
          fontSize: 13,
          lineHeight: 1.4,
          color: '#666',
        }}
      >
        Affordable protection for consultations,
        medicines and lab tests
      </p>
    </div>
  </div>

  {/* Price */}
  <div
    style={{
      marginTop: 12,
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '8px 12px',
      borderRadius: 999,
      background: '#fff',
      border: '1px solid #E8E1FB',
      fontSize: 12,
      fontWeight: 700,
    }}
  >
    <Shield size={12} color="var(--primary)" />
    From ${microinsuranceDailyPrice.toFixed(2)}/day
  </div>

  {/* Features */}
  <div
    style={{
      display: 'flex',
      gap: 8,
      marginTop: 12,
      overflowX: 'auto',
      paddingBottom: 4,
      scrollbarWidth: 'none',
    }}
  >
    {[
      {
        label: 'Consultations',
        icon: <Stethoscope size={12} />,
      },
      {
        label: 'Medicines',
        icon: <Pill size={12} />,
      },
      {
        label: 'Lab Tests',
        icon: <FlaskConical size={12} />,
      },
    ].map((item) => (
      <div
        key={item.label}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          padding: '8px 12px',
          background: '#fff',
          borderRadius: 12,
          border: '1px solid #E8E1FB',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        {item.icon}
        {item.label}
      </div>
    ))}
  </div>

  {/* CTA */}
  <button
    onClick={() => setActiveScreen('ManagePlan')}
    style={{
      width: '100%',
      height: 48,
      marginTop: 14,
      border: 'none',
      borderRadius: 14,
      background:
        'var(--primary)',
      color: '#fff',
      fontWeight: 700,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
    }}
  >
    Explore Plans
    <ChevronRight size={16} />
  </button>
</Card>
          <Card
            style={{
              width: "100%",
              borderRadius: 14,
              border: "1px solid #eceaf3",
              padding: 12,
              marginTop: 2,
              marginBottom: 8,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 12.5, letterSpacing: 0.4, marginBottom: 8, color: "#1f1d34" }}>
              Coverage Capability
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 8 }}>
              <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                <div style={{ color: "#6B6781", marginBottom: 2 }}>Consultations</div>
                <div style={{ fontWeight: 700, color: "#1f1d34" }}>{coverageEstimate?.consultation ?? 0}</div>
              </div>
              <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                <div style={{ color: "#6B6781", marginBottom: 2 }}>Medicine refills</div>
                <div style={{ fontWeight: 700, color: "#1f1d34" }}>{coverageEstimate?.medicineRefills ?? 0}</div>
              </div>
              <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                <div style={{ color: "#6B6781", marginBottom: 2 }}>Lab tests</div>
                <div style={{ fontWeight: 700, color: "#1f1d34" }}>{coverageEstimate?.labTests ?? 0}</div>
              </div>
              <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                <div style={{ color: "#6B6781", marginBottom: 2 }}>Emergency trips</div>
                <div style={{ fontWeight: 700, color: "#1f1d34" }}>{coverageEstimate?.emergencyTrips ?? 0}</div>
              </div>
            </div>
            {walletAlerts?.isLowBalance && (
              <div style={{ marginTop: 10, background: "#FFF4E5", color: "#9A3412", borderRadius: 10, padding: "7px 9px", fontSize: 11.5, fontWeight: 600 }}>
                Low balance alert: ${walletAlerts.balance?.toFixed?.(2) ?? walletBalance} left. Add funds for uninterrupted care.
              </div>
            )}
          </Card>

          {walletSummary && (
            <Card
              style={{
                width: "100%",
                borderRadius: 14,
                border: "1px solid #eceaf3",
                padding: 12,
                marginTop: 2,
                marginBottom: 8,
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 12.5, letterSpacing: 0.4, marginBottom: 8, color: "#1f1d34" }}>
                SPENDING SUMMARY
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 8 }}>
                <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                  <div style={{ color: "#6B6781", marginBottom: 2 }}>Reserved for care</div>
                  <div style={{ fontWeight: 700, color: "#1f1d34" }}>${Number(walletSummary.reservedForHealthcare || 0).toFixed(2)}</div>
                </div>
                <div style={{ background: "#F8F7FB", borderRadius: 10, padding: 8, fontSize: 11.5 }}>
                  <div style={{ color: "#6B6781", marginBottom: 2 }}>Recent transactions</div>
                  <div style={{ fontWeight: 700, color: "#1f1d34" }}>{Array.isArray(walletSummary.recentTransactions) ? walletSummary.recentTransactions.length : 0}</div>
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 11.5, fontWeight: 700, color: "#4A4660", marginBottom: 6 }}>Reserved by source</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 8 }}>
                  {Object.entries(walletSummary.reservedFunds || {})
                    .filter(([, value]) => Number(value || 0) > 0)
                    .map(([source, value]) => (
                      <div key={source} style={{ background: "#F8F7FB", borderRadius: 10, padding: 8 }}>
                        <div style={{ fontSize: 11, color: "#6B6781", textTransform: "capitalize" }}>{source.replace(/_/g, " ")}</div>
                        <div style={{ fontWeight: 700, fontSize: 13.5, color: "#1f1d34" }}>${Number(value || 0).toFixed(2)}</div>
                      </div>
                    ))}
                  {Object.entries(walletSummary.reservedFunds || {}).filter(([, value]) => Number(value || 0) > 0).length === 0 && (
                    <div style={{ ...emptyText, padding: 8, gridColumn: "1 / -1" }}>No source allocations yet.</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 11.5, fontWeight: 700, color: "#4A4660", marginBottom: 6 }}>Recent spend</div>
                {Array.isArray(walletSummary.recentTransactions) && walletSummary.recentTransactions.length > 0 ? (
                  walletSummary.recentTransactions.slice(0, 3).map((tx) => (
                    <div key={tx._id || tx.reference || `${tx.type}-${tx.createdAt}`} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "7px 2px", borderBottom: "1px solid #F0EEF7" }}>
                      <div>
                        <div style={{ fontSize: 12.5, fontWeight: 600, color: "#1f1d34", textTransform: "capitalize" }}>
                          {(tx.serviceCategory || tx.type || "care payment").replace(/_/g, " ")}
                        </div>
                        <div style={{ fontSize: 11, color: "#6B6781" }}>{new Date(tx.createdAt).toLocaleDateString()}</div>
                      </div>
                      <div style={{ fontSize: 12.5, fontWeight: 700, color: "#1f1d34" }}>${Number(tx.amount || 0).toFixed(2)}</div>
                    </div>
                  ))
                ) : (
                  <div style={{ ...emptyText, padding: 8 }}>No recent healthcare payments.</div>
                )}
              </div>
            </Card>
          )}

          {insuranceReminders.length > 0 && (
            <Card
              style={{
                width: "100%",
                borderRadius: 14,
                border: "1px solid #eceaf3",
                padding: 12,
                marginTop: 2,
                marginBottom: 8,
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 12.5, letterSpacing: 0.4, marginBottom: 8, color: "#1f1d34" }}>
                INSURANCE REMINDERS
              </div>
              {insuranceReminders.slice(0, 2).map((reminder, idx) => (
                <div
                  key={`${reminder.type}-${idx}`}
                  style={{
                    background: reminder.severity === 'high' ? '#FEF2F2' : reminder.severity === 'medium' ? '#FFFBEB' : '#F8F7FB',
                    border: reminder.severity === 'high' ? '1px solid #FECACA' : reminder.severity === 'medium' ? '1px solid #FDE68A' : '1px solid #E9E7F5',
                    borderRadius: 10,
                    padding: 9,
                    marginBottom: 8,
                  }}
                >
                  <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1f1d34' }}>{reminder.title}</div>
                  <div style={{ fontSize: 11.5, color: '#6B6781', marginTop: 2 }}>{reminder.message}</div>
                </div>
              ))}

              <button
                onClick={() => setActiveScreen('ManagePlan')}
                style={{
                  width: "100%",
                  border: "1px solid #E5E2EF",
                  borderRadius: 12,
                  padding: "10px 10px",
                  background: "#fff",
                  color: "#2F2B46",
                  fontWeight: 700,
                  fontSize: 13.5,
                }}
              >
                Review Insurance Plan
              </button>
            </Card>
          )}
        </div>
      </>
    )}




    {/* ================= QUICK CARE ACTIONS ================= */}
    <Card style={{
      padding: 18,
      width: "100%",
      maxWidth: 480,
      margin: "0 auto",
      background: "#fff",
      boxShadow: "0 2px 12px rgba(106,77,246,0.10)",
      borderRadius: 18,
      border: "1px solid #eceaf3",
      marginBottom: 28
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 14, fontFamily: 'Inter, Arial, sans-serif', letterSpacing: 0.2, color: "#1f1d34" }}>Quick care actions</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        {/* Consult Doctor */}
        <div
          onClick={() => setActiveScreen("PayProvider")}
          style={{
            borderRadius: 12,
            background: "var(--surface)",
            padding: "13px 24px 22px 8px", // increased right and bottom padding
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            boxShadow: "0 1px 4px rgba(106,77,246,0.06)",
            cursor: "pointer",
            position: "relative",
            border: "1px solid #eceaf3",
            minWidth: 0
          }}
        >
          <span style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: "#f0d3fd",
            marginBottom: 4,
          }}>
            <Stethoscope size={20} color="var(--primary)" strokeWidth={2} />
          </span>
          <div style={{ fontWeight: 700, fontSize: 11.5, color: "black", marginBottom: 1 }}>Consult Doctor</div>
          <div style={{ fontSize: 8.5, color: "#6B6781", marginBottom: 0 }}>Pay for appointments</div>
          <div style={{ position: "absolute", bottom: 7, right: 8 }}>
            <div style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--primary)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ChevronRight size={11} color="#fff" />
            </div>
          </div>
        </div>
        {/* Medicine & Labs */}
        <div
          onClick={() => setActiveScreen("PayProvider")}
          style={{
                        borderRadius: 12,
            background: "var(--surface)",
            padding: "13px 24px 22px 8px", // increased right and bottom padding
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            boxShadow: "0 1px 4px rgba(106,77,246,0.06)",
            cursor: "pointer",
            position: "relative",
            border: "1px solid #eceaf3",
            minWidth: 0
          }}
        >
          <span style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: "#f3e8ff",
            marginBottom: 4,
          }}>
            <FlaskConical size={20} color="var(--primary)" strokeWidth={2} />
          </span>
          <div style={{ fontWeight: 700, fontSize: 11.5, color: "black", marginBottom: 1 }}>Medicine & Labs</div>
          <div style={{ fontSize: 8.5, color: "#6B6781", marginBottom: 0 }}>Pay for drugs and tests</div>
          <div style={{ position: "absolute", bottom: 7, right: 8 }}>
            <div style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--primary)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ChevronRight size={11} color="#fff" />
            </div>
          </div>
        </div>
        {/* Claims */}
        <div
          onClick={() => setActiveScreen("ViewCoverage")}
          style={{
                       borderRadius: 12,
            background: "var(--surface)",
            padding: "13px 24px 22px 8px", // increased right and bottom padding
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            boxShadow: "0 1px 4px rgba(106,77,246,0.06)",
            cursor: "pointer",
            position: "relative",
            border: "1px solid #eceaf3",
            minWidth: 0
          }}
        >
          <span style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: "#cc97fd",
            marginBottom: 4,
          }}>
            <FileText size={20} color="var(--primary)" strokeWidth={2} />
          </span>
          <div style={{ fontWeight: 700, fontSize: 11.5, color: "black", marginBottom: 1 }}>Claims</div>
          <div style={{ fontSize: 8.5, color: "#6B6781", marginBottom: 0 }}>Track reimbursements</div>
          <div style={{ position: "absolute", bottom: 7, right: 8 }}>
            <div style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--primary)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ChevronRight size={11} color="#fff" />
            </div>
          </div>
        </div>
      </div>
    </Card>

   {/* ================= RECENT CARE PAYMENTS ================= */}
<Card style = {{marginTop : 12, }}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
     
      marginBottom: 12,
    }}
  >
    <div style={{ fontWeight: 700, fontSize: 14, fontFamily: 'Inter, Arial, sans-serif', letterSpacing: 0.2 }}>
      Recent care activities
    </div>

    <span
      style={{
        fontSize: 13,
        color: "#6D5EF6",
        cursor: "pointer",
        fontWeight: 500,
      }}
      onClick={() => setShowTransactionsModal(true)}
    >
      See all
    </span>
  </div>

  {transactions.length > 0 ? (
    transactions.slice(0, 3).map((tx, i) => (
      <TransactionItem key={tx._id || i} item={tx} />
    ))
  ) : (
    <div style={{ fontSize: 13, color: "#6B7280", textAlign: "center" }}>
      No recent care payments
    </div>
  )}
</Card>

{/* ================= TRANSACTIONS MODAL ================= */}
<TransactionsModal
  open={showTransactionsModal}
  onClose={() => setShowTransactionsModal(false)}
  transactions={transactions}
/>


  {/* ================= TRUST & DEPENDENTS ================= */}
<Card
  style={{
    background: "#ffffffff",
    border: "none",
    padding: "16px",
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
    }}
  >
    {/* Shield Icon */}
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        background: "#EEF2FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <i
        className="fi fi-sr-shield-check"
        style={{ color: "#6D5EF6", fontSize: 16 }}
      />
    </div>

    {/* Message */}
    <div style={{ flex: 1 }}>
      <div
        style={{
          fontSize: 10,
          color: "#4B5563",
          lineHeight: "1.5",
          fontWeight: 500,
        }}
      >
       <strong>Your health </strong> funds are secure and can only be used for approved medical
        services.
      </div>
    </div>

    {/* Supported Profiles */}
    <div
      style={{
        display: "flex",
        gap: 10,
        alignItems: "center",
      }}
    >
      {[
        { label: "You", emoji: <User size={18} color="#6D5EF6" /> },
        { label: dependents[0]?.relationship || "Child", emoji:  <Baby size={18} color="#6D5EF6" /> },
        { label: dependents.length > 1 ? `+${dependents.length - 1}` : "Parent", emoji: <Users size={18} color="#6D5EF6" /> },
      ].map((item) => ( 
        <div
          key={item.label}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: 11,
            color: "#374151",
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              background: "#EDE9FE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              marginBottom: 2,
            }}
          >
            {item.emoji}
          </div>
          {item.label}
        </div>
      ))}
    </div>
  </div>
</Card>


  </div>
);


const TransactionsModal = ({ open, onClose, transactions }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 2000,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      {/* Modal sheet */}
      <div
        style={{
          width: "100%",
          maxWidth: 480,
          maxHeight: "85vh",
          background: "#ffffffff",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 16,
          overflowY: "auto",
          animation: "slideUp 0.25s ease",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 14 }}>
            All Care Payments
          </div>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "#F3F4F6",
              borderRadius: 10,
              padding: "6px 10px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            X
          </button>
        </div>

        {/* Transactions */}
        {transactions.length > 0 ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {transactions.map((tx, i) => {
              const isCovered = tx.type === "insurance_payment";
              const isCompleted = tx.status === "completed";

              return (
                <div
                  key={tx._id || i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 12,
                    borderRadius: 14,
                    background: "#F7F7FB",
                  }}
                >
                  {/* Icon */}
                <div
  style={{
    width: 48,
    height: 48,
    borderRadius: 12,
    background: getTransactionColor(tx.type),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 14,
  }}
>
  {getTransactionIcon(tx.type)}
</div>


                  {/* Info */}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>
                      {getCareDescription(tx)}

                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#6B7280",
                        marginTop: 2,
                      }}
                    >
                      {new Date(tx.createdAt).toLocaleDateString()}
                    </div>

                    {isCovered && (
                      <div
                        style={{
                          marginTop: 6,
                          display: "inline-block",
                          fontSize: 11,
                          padding: "3px 8px",
                          borderRadius: 999,
                          background: "#ECFDF5",
                          color: "#047857",
                          fontWeight: 600,
                        }}
                      >
                        Covered by HMO
                      </div>
                    )}

                    {!isCovered && isCompleted && (
                      <div
                        style={{
                          marginTop: 6,
                          display: "inline-block",
                          fontSize: 11,
                          padding: "3px 8px",
                          borderRadius: 999,
                          background: "#EEF2FF",
                          color: "#4338CA",
                          fontWeight: 600,
                        }}
                      >
                        Completed
                      </div>
                    )}
                  </div>

                  {/* Amount */}
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 14,
                      marginLeft: 12,
                    }}
                  >
                    ${tx.amount.toFixed(2)}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: 24,
              color: "#6B7280",
              fontSize: 14,
            }}
          >
            No transactions found
          </div>
        )}
      </div>
    </div>
  );
};

const QuickActions = React.memo(({ handleMouseEnter, handleMouseLeave }) => (
  <div style={styles.quickActions}>
    {[
      { icon: <img style={{width : 25, height : 25}} src={pay}></img>, label: "Deposit" },
      { icon: <img style={{width : 25, height : 25}} src={withdraw}></img>, label: "Withdraw" },
    ].map((item, idx) => (
      <div
        key={idx}
        style={styles.actionCard}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => {item.label == "Deposit" ? setActiveScreen("AddMoney") : setActiveScreen("Withdraw")} }
      >
        <div>{item.icon}</div>
        <h6 style={styles.actionText}>{item.label}</h6>
      </div>
    ))}
  </div>
));

const careTile = {
  
  borderRadius: 14,
  padding: 12,
  textAlign: "center",
  justifyContent : "center",
  alignItems : "center",
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  gap: 6,
};

  // ------------------ ADD MONEY ------------------
  const AddMoney = () => {
    const stripe = useStripe();
    const elements = useElements();

    const [selectedAmount, setSelectedAmount] = useState(null);
    const [customAmount, setCustomAmount] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("mobile_money");
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [cardComplete, setCardComplete] = useState(false);
    const [fundingContext, setFundingContext] = useState({
      dependents: [],
      employerProfiles: [],
      donorVouchers: [],
    });
    const [isContextLoading, setIsContextLoading] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
      phoneNumber: "",
      network: "",
      bankName: "",
      accountName: "",
      accountNumber: "",
      voucherCode: "",
      employerName: "",
      staffId: "",
      supporterName: "",
      supporterPhone: "",
      cardHolderName: "",
      reference: "",
      selectedDependentId: "",
      selectedEmployerProfileId: "",
      selectedVoucherCode: "",
      allowedServiceCategories: ["consultation", "medicine", "lab_test", "emergency_transport", "remote_monitoring", "health_records", "insurance_premium", "preventive_care"],
    });

    const familySupportCategoryOptions = [
      { value: "consultation", label: "Doctor consultations (chat/audio/video/specialist)" },
      { value: "medicine", label: "Pharmacy (prescription, OTC, refills)" },
      { value: "lab_test", label: "Lab tests (home/workplace/lab visit)" },
      { value: "emergency_transport", label: "Emergency care (ambulance/urgent transport)" },
      { value: "remote_monitoring", label: "Remote monitoring (BP, glucose, vitals)" },
      { value: "health_records", label: "Health records (uploads/reports/docs fees)" },
      { value: "insurance_premium", label: "Insurance contributions (premium/co-pay)" },
      { value: "preventive_care", label: "Preventive care (screening/vaccination/wellness)" },
    ];

    const amount = selectedAmount || customAmount;

    const fundingMethodMeta = {
      mobile_money: {
        title: "Mobile Money",
        subtitle: "Enter the mobile wallet that will authorize this payment.",
        fields: [
          { key: "phoneNumber", label: "Mobile number", placeholder: "e.g. +233 24 000 0000" },
          {
            key: "network",
            label: "Network",
            type: "select",
            options: ["MTN", "Orange"],
          },
          { key: "reference", label: "Payment reference", placeholder: "Optional reference or receipt number" },
        ],
        helper: "Use the registered mobile wallet number for this payment method.",
      },
      card: {
        title: "Credit Card",
        subtitle: "Confirm the card payment and enter the cardholder name.",
        fields: [
          { key: "cardHolderName", label: "Cardholder name", placeholder: "Name on card" },
        ],
        helper: "The secure card element below will collect the card details.",
      },
      bank_transfer: {
        title: "Bank Transfer",
        subtitle: "Add the bank details or transfer reference for the payment.",
        fields: [
          { key: "bankName", label: "Bank name", placeholder: "e.g. Bank of Africa" },
          { key: "accountName", label: "Account name", placeholder: "Account holder name" },
          { key: "accountNumber", label: "Account number", placeholder: "Bank account number" },
          { key: "reference", label: "Transfer reference", placeholder: "Bank transfer reference" },
        ],
        helper: "Use this when funds are sent from another bank account.",
      },
      employer_contribution: {
        title: "Employer Support",
        subtitle: "Capture the employer contribution details for this top-up.",
        fields: [
          { key: "employerName", label: "Employer name", placeholder: "Company or organization" },
          { key: "staffId", label: "Staff ID", placeholder: "Employee or payroll ID" },
          { key: "reference", label: "Payroll reference", placeholder: "Payroll or contribution reference" },
        ],
        helper: "Use this when your employer is funding the wallet.",
      },
      donor_voucher: {
        title: "Donor Voucher",
        subtitle: "Enter the voucher code supplied by the donor or sponsor.",
        fields: [
          { key: "voucherCode", label: "Voucher code", placeholder: "Donation or voucher code" },
          { key: "reference", label: "Voucher reference", placeholder: "Optional voucher reference" },
        ],
        helper: "Use this when the funding comes from a sponsor voucher.",
      },
      family_support: {
        title: "Family Support",
        subtitle: "Enter the relative or supporter details for this top-up.",
        fields: [
          { key: "supporterName", label: "Supporter name", placeholder: "Family member name" },
          { key: "supporterPhone", label: "Supporter phone", placeholder: "Supporter phone number" },
          { key: "reference", label: "Support note", placeholder: "Optional note or reference" },
        ],
        helper: "Use this when family is contributing to the wallet.",
      },
    };

    const selectedMethodMeta = fundingMethodMeta[paymentMethod] || fundingMethodMeta.mobile_money;

    const loadFundingContext = async () => {
      try {
        setIsContextLoading(true);
        const response = await Services.wallet.getFundingContext();
        setFundingContext({
          dependents: Array.isArray(response?.context?.dependents) ? response.context.dependents : [],
          employerProfiles: Array.isArray(response?.context?.employerProfiles) ? response.context.employerProfiles : [],
          donorVouchers: Array.isArray(response?.context?.donorVouchers) ? response.context.donorVouchers : [],
        });
      } catch (error) {
        console.error("Failed to load funding context", error);
      } finally {
        setIsContextLoading(false);
      }
    };

    useEffect(() => {
      loadFundingContext();
    }, []);

    const openPaymentModal = (method) => {
      setPaymentMethod(method);
      setShowPaymentModal(true);
    };

    const handleAddEmployerProfile = async () => {
      if (!paymentDetails.employerName.trim()) {
        alert("Enter employer name first.");
        return;
      }

      try {
        const response = await Services.wallet.addEmployerSupportProfile({
          name: paymentDetails.employerName,
          staffId: paymentDetails.staffId,
          reference: paymentDetails.reference,
        });

        const profiles = Array.isArray(response?.employerProfiles) ? response.employerProfiles : [];
        setFundingContext((prev) => ({ ...prev, employerProfiles: profiles }));
        if (profiles.length > 0) {
          const latest = profiles[profiles.length - 1];
          setPaymentDetails((prev) => ({ ...prev, selectedEmployerProfileId: String(latest._id || "") }));
        }
        alert("Employer profile saved.");
      } catch (error) {
        alert(error?.response?.data?.error || error?.message || "Failed to save employer profile.");
      }
    };

    const handleAddVoucher = async () => {
      if (!paymentDetails.voucherCode.trim()) {
        alert("Enter voucher code first.");
        return;
      }

      try {
        const response = await Services.wallet.redeemDonorVoucher({
          code: paymentDetails.voucherCode,
        });

        const vouchers = Array.isArray(response?.donorVouchers) ? response.donorVouchers : [];
        setFundingContext((prev) => ({ ...prev, donorVouchers: vouchers }));
        setPaymentDetails((prev) => ({
          ...prev,
          selectedVoucherCode: String(paymentDetails.voucherCode || "").trim().toUpperCase(),
        }));
        alert("Voucher linked to wallet.");
      } catch (error) {
        alert(error?.response?.data?.error || error?.message || "Failed to redeem voucher.");
      }
    };

  // Γ£à THIS is the async function
  const handleAddMoney = async () => {

    if (!amount || amount <= 0) {
      alert("Invalid amount");
      return;
    }

    if (paymentMethod === "family_support" && !paymentDetails.selectedDependentId) {
      alert("Select a dependent for family support.");
      return;
    }

    if (paymentMethod === "family_support" && paymentDetails.allowedServiceCategories.length === 0) {
      alert("Select at least one allowed care use for family support.");
      return;
    }

    if (paymentMethod === "employer_contribution" && !paymentDetails.selectedEmployerProfileId) {
      alert("Select an employer profile.");
      return;
    }

    if (paymentMethod === "donor_voucher" && !paymentDetails.selectedVoucherCode) {
      alert("Select a donor voucher.");
      return;
    }

    if (paymentMethod === "card") {
      if (!stripe || !elements) {
        alert("Stripe not ready");
        return;
      }
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        alert("Card input not ready");
        return;
      }
    }

    try {
      setIsLoading(true);

      if (paymentMethod === "card") {
        // 1. Create PaymentIntent
        const { data } = await api.post("/api/wallet/deposit", {
          amount,
          userId,
        });
        console.log("Stripe response:", data);
        const { clientSecret } = data;

        // 2. Confirm card payment
        const result = await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        });

        if (result.error) {
          throw new Error(result.error.message);
        }

        if (result.paymentIntent.status === "succeeded") {
          await Services.wallet.addFundingSource({
            amount: Number(amount),
            sourceType: "card",
            sourceLabel: paymentDetails.cardHolderName
              ? `Credit Card - ${paymentDetails.cardHolderName}`
              : "Credit Card",
          });
          await fetchDashboardData();
          alert("Payment successful! Health wallet updated.");
        }
      } else {
        const detailSummary = [
          paymentDetails.phoneNumber,
          paymentDetails.network,
          paymentDetails.bankName,
          paymentDetails.accountName,
          paymentDetails.accountNumber,
          paymentDetails.voucherCode,
          paymentDetails.employerName,
          paymentDetails.staffId,
          paymentDetails.supporterName,
          paymentDetails.supporterPhone,
          paymentDetails.reference,
        ]
          .filter(Boolean)
          .join(" • ");

        const fundingResponse = await Services.wallet.addFundingSource({
          amount: Number(amount),
          sourceType: paymentMethod,
          sourceLabel: detailSummary || paymentMethod.split('_').join(' '),
          sourceContext: {
            phoneNumber: paymentDetails.phoneNumber || null,
            network: paymentDetails.network || null,
            dependentId: paymentDetails.selectedDependentId || null,
            employerProfileId: paymentDetails.selectedEmployerProfileId || null,
            voucherCode: paymentDetails.selectedVoucherCode || null,
            sponsorName: paymentDetails.supporterName || null,
            sponsorPhone: paymentDetails.supporterPhone || null,
            reference: paymentDetails.reference || null,
            allowedServiceCategories: paymentMethod === "family_support"
              ? paymentDetails.allowedServiceCategories
              : undefined,
          },
        });
        if (paymentMethod === "mobile_money" && fundingResponse?.referenceId) {
          alert("Payment request sent. Approve it on your phone.");
          let latestStatus = "PROCESSING";
          for (let attempt = 0; attempt < 12; attempt += 1) {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            const statusResponse = await Services.wallet.getFundingSourceStatus(fundingResponse.referenceId);
            latestStatus = String(statusResponse?.status || "PROCESSING").toUpperCase();
            if (["COMPLETED", "FAILED", "CANCELED", "CANCELLED"].includes(latestStatus)) break;
          }
          if (latestStatus === "COMPLETED") {
            alert("Payment confirmed. Your health wallet has been updated.");
          } else if (["FAILED", "CANCELED", "CANCELLED"].includes(latestStatus)) {
            throw new Error("The mobile-money payment was not completed.");
          } else {
            alert("Payment is still processing. Your wallet will update after Dollr confirms it.");
          }
        }
        await fetchDashboardData();
        await loadFundingContext();
        if (paymentMethod !== "mobile_money") alert("Funds added successfully.");
      }

      setShowPaymentModal(false);
      setPaymentDetails({
        phoneNumber: "",
        network: "",
        bankName: "",
        accountName: "",
        accountNumber: "",
        voucherCode: "",
        employerName: "",
        staffId: "",
        supporterName: "",
        supporterPhone: "",
        cardHolderName: "",
        reference: "",
        selectedDependentId: "",
        selectedEmployerProfileId: "",
        selectedVoucherCode: "",
        allowedServiceCategories: ["consultation", "medicine", "lab_test", "emergency_transport", "remote_monitoring", "health_records", "insurance_premium", "preventive_care"],
      });

    } catch (err) {
      alert(err.response?.data?.message || err.message);
    } finally {
      setIsLoading(false);
    }
  };

    return (
      <div
        style={{
          maxWidth: "480px",
          margin: "0 auto",
          padding: "0 0 calc(120px + env(safe-area-inset-bottom)) 0",
          fontFamily: "Inter, system-ui, sans-serif",
          background: "#F9FAFB",
          minHeight: "100vh",
        }}
      >
        {/* Brand Banner with Back Arrow */}
        <div style={{
          width: "100%",
          minHeight: 90,
          background: "linear-gradient(90deg, #704af6 0%, #8F6BFF 100%)",
          borderRadius: "0 0 22px 22px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          padding: "18px 22px 10px 22px",
          marginBottom: 24,
          boxShadow: "0 2px 12px rgba(106,77,246,0.07)",
          position: "relative"
        }}>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
              <i
                className="fi fi-br-angle-left"
                onClick={() => setActiveScreen("Dashboard")}
                style={{
                  ...styles.backArrow,
                  marginRight: 10,
                  background: "rgba(255,255,255,0.18)",
                  borderRadius: "50%",
                  width: 34,
                  height: 34,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  color: "#fff",
                  boxShadow: "0 1px 4px rgba(112,74,246,0.10)",
                  transition: "background 0.2s"
                }}
                tabIndex={0}
                role="button"
                aria-label="Back"
              />
              <div style={{ fontWeight: 700, fontSize: 19, letterSpacing: -0.2, color: "#fff" }}>
                Add Funds to Your Wallet
              </div>
            </div>
            <div style={{ fontSize: 13.5, opacity: 0.93, fontWeight: 500, color: "#fff" }}>
              Secure your care. Top up instantly with your preferred method.
            </div>
          </div>
          <img
            src={require("../assets/icons/purse.png")}
            alt="Wallet Promo"
            style={{ width: 62, height: "auto", marginLeft: 18, flexShrink: 0, display: "block" }}
          />
        </div>

        {/* Amount Section */}
        <div
          style={{
            background: "#FFFFFF",
            padding: "24px",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(112,74,246,0.07)",
            marginBottom: "20px",
            border: "1.5px solid #ede9fe"
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              fontWeight: 700,
              fontSize: 14,
              color: "#704af6",
              letterSpacing: -0.2
            }}
          >
            Select Amount
          </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
          marginBottom: "20px",
        }}
      >
        {[5, 10, 20, 50, 100].map((amt) => (
          <button
            key={amt}
            onClick={() => {
              setSelectedAmount(amt);
              setCustomAmount("");
            }}
            style={{
              padding: "16px 10px",
              borderRadius: "16px",
              border:
                selectedAmount === amt
                  ? "2px solid #704af6"
                  : "2px solid #E5E7EB",
              background:
                selectedAmount === amt
                  ? "rgba(112,74,246,0.10)"
                  : "#F6F7FB",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              fontWeight: 600,
            }}
          >
            <div style={{ fontSize: "1.1rem", color: selectedAmount === amt ? "#704af6" : "#2d1d5a", fontWeight: 700 }}>${amt}</div>
            <div style={{ fontSize: "0.75rem", opacity: 0.7, color: selectedAmount === amt ? "#704af6" : undefined }}>Add</div>
          </button>
        ))}

        {/* Custom Box */}
        <div
          onClick={() =>
            document.getElementById("customAmount")?.focus()
          }
          style={{
            borderRadius: "16px",
            border: customAmount
              ? "2px solid #704af6"
              : "2px dashed #E5E7EB",
            background: customAmount
              ? "rgba(112,74,246,0.07)"
              : "#F6F7FB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            cursor: "pointer",
            padding: "16px",
            transition: "all 0.2s ease",
          }}
        >
            <div style={{ fontSize: "1.3rem", color: "#704af6", fontWeight: 700 }}>+</div>
            <div style={{ fontSize: "0.75rem", color: "#704af6", fontWeight: 600 }}>
              Custom
            </div>
        </div>
      </div>

      {/* Custom Input */}
      <div>
        <div
          style={{
            marginBottom: "8px",
            fontWeight: 600,
            fontSize: "0.9rem",
            color: "#374151",
          }}
        >
          Custom Amount
        </div>

        <input
          id="customAmount"
          type="number"
          placeholder="Enter amount"
          value={customAmount}
          onChange={(e) => {
            setCustomAmount(e.target.value);
            setSelectedAmount(null);
          }}
          style={{
            width: "100%",
            padding: "16px",
            borderRadius: "14px",
            border: "2px solid #E5E7EB",
            background: "#F6F7FB",
            fontSize: "1rem",
            fontWeight: 600,
            textAlign: "center",
            outline: "none",
            transition: "all 0.2s ease",
          }}
        />
      </div>
    </div>

    {/* Payment Method Section */}
        <div
          style={{
            background: "#FFFFFF",
            padding: "24px",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(112,74,246,0.07)",
            marginBottom: "20px",
            border: "1.5px solid #ede9fe"
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              fontWeight: 700,
              fontSize: 14,
              color: "#704af6",
              letterSpacing: -0.2
            }}
          >
            Payment Method
          </div>

        {[
        { method: "mobile_money", label: "Mobile Money", icon : <Phone /> },
        { method: "card", label: "Credit Card", icon: <CreditCard /> },
        { method: "bank_transfer", label: "Bank Transfer", icon: <Building /> },
        { method: "employer_contribution", label: "Employer Support", icon: <Building /> },
        { method: "donor_voucher", label: "Donor Voucher", icon: <Banknote /> },
        { method: "family_support", label: "Family Support", icon: <Users /> },
      ].map((item) => (
        <div
          key={item.method}
          onClick={() => openPaymentModal(item.method)}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "16px",
            borderRadius: "14px",
            border:
              paymentMethod === item.method
                ? "2px solid #704af6"
                : "2px solid #E5E7EB",
            background:
              paymentMethod === item.method
                ? "rgba(112,74,246,0.07)"
                : "#F6F7FB",
            cursor: "pointer",
            marginBottom: "12px",
            transition: "all 0.2s ease",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: paymentMethod === item.method ? "#ede9fe" : "#EEF2FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            {item.icon}
          </div>

          <div style={{ flex: 1, fontWeight: 600 }}>
            {item.label}
          </div>
        </div>
      ))}

    </div>

    {/* CTA */}
        <button
          onClick={() => openPaymentModal(paymentMethod)}
          disabled={
            isLoading ||
            !amount
          }
          style={{
            width: "100%",
            padding: "15px",
            borderRadius: "14px",
            border: "none",
            background: "linear-gradient(90deg, #704af6 0%, #8F6BFF 100%)",
            color: "#fff",
            fontWeight: 700,
            fontSize: "1.08rem",
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity:
              isLoading ||
              !amount
                ? 0.6
                : 1,
            transition: "all 0.2s ease",
            boxShadow: "0 4px 16px rgba(112,74,246,0.13)",
            marginTop: 8,
            marginBottom: "calc(16px + env(safe-area-inset-bottom))"
          }}
        >
          {isLoading ? "Processing..." : "Continue to Payment"}
        </button>

      {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(17, 24, 39, 0.58)",
            zIndex: 20000,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            padding: "0 12px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 520,
              maxHeight: "92vh",
              overflowY: "auto",
              background: "#fff",
              borderTopLeftRadius: 24,
              borderTopRightRadius: 24,
              padding: "20px 20px calc(110px + env(safe-area-inset-bottom)) 20px",
              boxShadow: "0 -20px 50px rgba(0,0,0,0.2)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#111827" }}>{selectedMethodMeta.title}</div>
                <div style={{ fontSize: 13, color: "#6B7280", marginTop: 4 }}>{selectedMethodMeta.subtitle}</div>
              </div>
              <button
                onClick={() => setShowPaymentModal(false)}
                style={{
                  border: "none",
                  background: "#F3F4F6",
                  borderRadius: 10,
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Close
              </button>
            </div>

            <div style={{ padding: 14, borderRadius: 16, background: "#F9FAFB", marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 4 }}>Funding amount</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: "#704af6" }}>${Number(amount || 0).toFixed(2)}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {selectedMethodMeta.fields.map((field) => {
                if (field.type === "select") {
                  return (
                    <div key={field.key}>
                      <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#374151" }}>{field.label}</div>
                      <select
                        value={paymentDetails[field.key]}
                        onChange={(e) => setPaymentDetails((prev) => ({ ...prev, [field.key]: e.target.value }))}
                        style={{
                          width: "100%",
                          padding: "14px 16px",
                          borderRadius: 14,
                          border: "2px solid #E5E7EB",
                          background: "#F9FAFB",
                          fontWeight: 600,
                          outline: "none",
                        }}
                      >
                        <option value="">Select {field.label.toLowerCase()}</option>
                        {field.options.map((option) => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                  );
                }

                return (
                  <div key={field.key}>
                    <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#374151" }}>{field.label}</div>
                    <input
                      type="text"
                      value={paymentDetails[field.key]}
                      onChange={(e) => setPaymentDetails((prev) => ({ ...prev, [field.key]: e.target.value }))}
                      placeholder={field.placeholder}
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        borderRadius: 14,
                        border: "2px solid #E5E7EB",
                        background: "#F9FAFB",
                        fontWeight: 600,
                        outline: "none",
                      }}
                    />
                  </div>
                );
              })}

              {paymentMethod === "family_support" && (
                <div>
                  <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#374151" }}>Choose dependent from app</div>
                  <select
                    value={paymentDetails.selectedDependentId}
                    onChange={(e) => setPaymentDetails((prev) => ({ ...prev, selectedDependentId: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      borderRadius: 14,
                      border: "2px solid #E5E7EB",
                      background: "#F9FAFB",
                      fontWeight: 600,
                      outline: "none",
                    }}
                  >
                    <option value="">Select dependent</option>
                    {(fundingContext.dependents || []).map((dependent) => (
                      <option key={dependent._id} value={dependent._id}>
                        {dependent.fullName} ({dependent.relationship})
                      </option>
                    ))}
                  </select>
                  <div style={{ marginTop: 12, marginBottom: 6, fontWeight: 700, fontSize: 13, color: "#374151" }}>
                    Allowed care uses
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: 8,
                    }}
                  >
                    {familySupportCategoryOptions.map((option) => {
                      const checked = paymentDetails.allowedServiceCategories.includes(option.value);
                      return (
                        <label
                          key={option.value}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 10,
                            padding: "11px 12px",
                            width: "100%",
                            minWidth: 0,
                            boxSizing: "border-box",
                            borderRadius: 12,
                            background: checked ? "#F3EEFF" : "#F9FAFB",
                            border: checked ? "1px solid #BFA8FF" : "1px solid #E5E7EB",
                            fontSize: 12.5,
                            fontWeight: 600,
                            color: "#374151",
                            lineHeight: 1.35,
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            style={{ marginTop: 2, accentColor: "var(--primary)", width: 15, height: 15, flexShrink: 0 }}
                            onChange={(e) => {
                              setPaymentDetails((prev) => ({
                                ...prev,
                                allowedServiceCategories: e.target.checked
                                  ? [...prev.allowedServiceCategories, option.value]
                                  : prev.allowedServiceCategories.filter((category) => category !== option.value),
                              }));
                            }}
                          />
                          <span style={{ flex: 1, minWidth: 0, overflowWrap: "anywhere" }}>{option.label}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              )}

              {paymentMethod === "employer_contribution" && (
                <div>
                  <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#374151" }}>Choose employer profile</div>
                  <select
                    value={paymentDetails.selectedEmployerProfileId}
                    onChange={(e) => setPaymentDetails((prev) => ({ ...prev, selectedEmployerProfileId: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      borderRadius: 14,
                      border: "2px solid #E5E7EB",
                      background: "#F9FAFB",
                      fontWeight: 600,
                      outline: "none",
                    }}
                  >
                    <option value="">Select employer</option>
                    {(fundingContext.employerProfiles || []).map((profile) => (
                      <option key={profile._id} value={profile._id}>
                        {profile.name}{profile.staffId ? ` (${profile.staffId})` : ""}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleAddEmployerProfile}
                    type="button"
                    style={{
                      marginTop: 10,
                      border: "none",
                      background: "#EDE9FE",
                      color: "#5B21B6",
                      borderRadius: 10,
                      padding: "8px 12px",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Save as employer profile
                  </button>
                </div>
              )}

              {paymentMethod === "donor_voucher" && (
                <div>
                  <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#374151" }}>Choose donor voucher</div>
                  <select
                    value={paymentDetails.selectedVoucherCode}
                    onChange={(e) => setPaymentDetails((prev) => ({ ...prev, selectedVoucherCode: e.target.value }))}
                    style={{
                      width: "100%",
                      padding: "14px 16px",
                      borderRadius: 14,
                      border: "2px solid #E5E7EB",
                      background: "#F9FAFB",
                      fontWeight: 600,
                      outline: "none",
                    }}
                  >
                    <option value="">Select voucher</option>
                    {(fundingContext.donorVouchers || []).map((voucher) => (
                      <option key={voucher._id || voucher.code} value={voucher.code}>
                        {voucher.code} - ${Number(voucher.amountRemaining || 0).toFixed(2)}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleAddVoucher}
                    type="button"
                    style={{
                      marginTop: 10,
                      border: "none",
                      background: "#EDE9FE",
                      color: "#5B21B6",
                      borderRadius: 10,
                      padding: "8px 12px",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Redeem and link voucher
                  </button>
                </div>
              )}

              {isContextLoading && ["family_support", "employer_contribution", "donor_voucher"].includes(paymentMethod) && (
                <div style={{ fontSize: 12, color: "#6B7280" }}>Loading linked in-app sources...</div>
              )}
            </div>

            {selectedMethodMeta.helper && (
              <div style={{ marginTop: 14, fontSize: 12.5, color: "#6B7280", lineHeight: 1.5 }}>
                {selectedMethodMeta.helper}
              </div>
            )}

            {paymentMethod === "card" && (
              <div style={{ marginTop: 16 }}>
                <div style={{ marginBottom: 8, fontWeight: 600, fontSize: "0.9rem", color: "#374151" }}>Card Details</div>
                <div style={{ padding: 16, borderRadius: 14, border: "2px solid #E5E7EB", background: "#F9FAFB" }}>
                  <CardElement
                    options={{
                      hidePostalCode: true,
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#111827",
                          fontFamily: "Inter, system-ui, sans-serif",
                          "::placeholder": { color: "#9CA3AF" },
                        },
                        invalid: { color: "#EF4444" },
                      },
                    }}
                    onChange={(event) => setCardComplete(event.complete)}
                  />
                </div>
              </div>
            )}

            <button
              onClick={handleAddMoney}
              disabled={isLoading || (paymentMethod === "card" && !cardComplete)}
              style={{
                width: "100%",
                padding: "15px",
                borderRadius: "14px",
                border: "none",
                background: "linear-gradient(90deg, #704af6 0%, #8F6BFF 100%)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "1.08rem",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading || (paymentMethod === "card" && !cardComplete) ? 0.6 : 1,
                transition: "all 0.2s ease",
                boxShadow: "0 4px 16px rgba(112,74,246,0.13)",
                marginTop: 18,
              }}
            >
              {isLoading ? "Processing..." : "Confirm Payment"}
            </button>
          </div>
        </div>
      )}
      </div>
);

  };

  // ------------------ WITHDRAW ------------------
  const Withdraw = () => {
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawalMethod, setWithdrawalMethod] = useState("bank_transfer");

    const handleWithdrawSubmit = async () => {
      if (!withdrawAmount || parseFloat(withdrawAmount) <= 0) {
        alert("Please enter a valid amount");
        return;
      }

      if (parseFloat(withdrawAmount) > walletBalance) {
        alert("Insufficient balance");
        return;
      }

      await handleWithdraw(withdrawAmount, withdrawalMethod);
      setWithdrawAmount("");
      setActiveScreen("Dashboard");
    };

    return (
      <div style={{ maxWidth: "500px", margin: "0 auto" }}>
        <Header title="Withdraw Funds" />
        <Card>
          <div style={{ marginBottom: "20px", fontWeight: 600, fontSize: "1.1rem", color: "#2D3436" }}>Withdrawal Method</div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {["bank_transfer", "mobile_money", "digital_wallet"].map((method) => (
              <Button 
                key={method}
                type={withdrawalMethod === method ? "primary" : "secondary"}
                onClick={() => setWithdrawalMethod(method)}
                style={{ flex: 1 }}
              >
                {method.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </Button>
            ))}
          </div>
        </Card>
        
        <Card>
          <div style={{ marginBottom: "16px", fontWeight: 600, color: "#2D3436" }}>Enter Amount</div>
          <div style={{ position: "relative", marginBottom: "24px" }}>
            <div style={{
              position: "absolute",
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "1.5rem",
              fontWeight: 700,
              color: "#704af6"
            }}>$</div>
            <input 
              type="number" 
              placeholder="0.00"
              value={withdrawAmount} 
              onChange={(e) => setWithdrawAmount(e.target.value)}
              style={{ 
                width: "100%", 
                padding: "16px 16px 16px 48px", 
                borderRadius: "14px", 
                border: "2px solid #E9ECEF",
                background: "#F8F9FA",
                fontWeight: 700, 
                fontSize: "1.5rem",
                transition: "all 0.2s ease",
                ":focus": {
                  outline: "none",
                  borderColor: "#704af6",
                  boxShadow: "0 0 0 3px rgba(112, 74, 246, 0.1)"
                }
              }}
            />
          </div>
          
          <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            padding: "16px",
            borderRadius: "12px",
            background: "rgba(112, 74, 246, 0.05)",
            marginBottom: "20px"
          }}>
            <div style={{ color: "#636E72", fontSize: "0.9rem" }}>Available Balance</div>
            <div style={{ fontWeight: 700, fontSize: "1.2rem", color: "#2D3436" }}>${walletBalance.toFixed(2)}</div>
          </div>
          
          <Button 
            type="primary" 
            onClick={handleWithdrawSubmit}
            style={{ width: "100%" }}
            loading={isLoading}
          >
            Confirm Withdrawal
          </Button>
        </Card>
      </div>
    );
  };

  // ------------------ PAY PROVIDER ------------------
  
const PayProviderScreen = () => {
  const [payAmount, setPayAmount] = useState("");
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [serviceDetails, setServiceDetails] = useState("");
  const [serviceCategory, setServiceCategory] = useState("consultation");
  const [selectedDependentId, setSelectedDependentId] = useState("");
  const [useSplitPayment, setUseSplitPayment] = useState(false);
  const [splitAllocation, setSplitAllocation] = useState({
    walletBalance: "",
    familySupport: "",
    employerSupport: "",
    donorVoucher: "",
    insuranceCoverage: "",
  });
  const [coveragePreview, setCoveragePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [scanning, setScanning] = useState(false);

  const approvedCategories = [
    { value: "consultation", label: "Doctor consultations (chat/audio/video/specialist)" },
    { value: "medicine", label: "Pharmacy (prescription, OTC, refills)" },
    { value: "lab_test", label: "Lab tests (home/workplace/lab visit)" },
    { value: "emergency_transport", label: "Emergency care (ambulance/urgent transport)" },
    { value: "remote_monitoring", label: "Remote monitoring (BP, glucose, vitals)" },
    { value: "health_records", label: "Health records (uploads/reports/docs fees)" },
    { value: "preventive_care", label: "Preventive care (screening/vaccination/wellness)" },
    { value: "follow_up", label: "Follow-up Care" },
    { value: "insurance_premium", label: "Insurance contributions (premium/co-pay)" },
  ];

  const providerList = Array.isArray(providers) ? providers : [];
  const amountValue = Number(payAmount || 0);
  const expectedCoverageAmount = Number(
    coveragePreview?.covered ? coveragePreview.coveredAmount || 0 : 0
  );
  const numericSplit = {
    walletBalance: Number(splitAllocation.walletBalance || 0),
    familySupport: Number(splitAllocation.familySupport || 0),
    employerSupport: Number(splitAllocation.employerSupport || 0),
    donorVoucher: Number(splitAllocation.donorVoucher || 0),
    insuranceCoverage: Number(splitAllocation.insuranceCoverage || 0),
  };
  const splitTotal = Object.values(numericSplit).reduce((sum, value) => sum + value, 0);
  const walletDebitFromSplit =
    numericSplit.walletBalance +
    numericSplit.familySupport +
    numericSplit.employerSupport +
    numericSplit.donorVoucher;
  const isSplitValid = useSplitPayment
    ? Math.round(splitTotal * 100) === Math.round(amountValue * 100) && walletDebitFromSplit <= walletBalance
    : true;
  const walletRequiredAfterCoverage = Math.max(0, amountValue - expectedCoverageAmount);
  const canPayWithoutSplit = amountValue > 0 && walletBalance >= walletRequiredAfterCoverage;

const isFormValid =
  selectedProvider &&
  serviceCategory &&
  serviceDetails.trim() !== "" &&
  payAmount &&
  amountValue > 0 &&
  (useSplitPayment ? isSplitValid : canPayWithoutSplit);

  useEffect(() => {
    const loadCoveragePreview = async () => {
      if (!selectedProvider || !payAmount || amountValue <= 0) {
        setCoveragePreview(null);
        return;
      }

      try {
        const serviceType = SERVICE_TYPE_ALIASES[serviceCategory] || serviceCategory;
        const response = await Services.insurance.checkServiceCoverage({
          serviceType,
          amount: amountValue,
          providerId: selectedProvider._id,
          userId: localStorage.getItem('userId'),
        });

        setCoveragePreview(response?.data || response || null);
      } catch (error) {
        setCoveragePreview(null);
      }
    };

    loadCoveragePreview();
  }, [selectedProvider, payAmount, amountValue, serviceCategory]);

  useEffect(() => {
    if (!useSplitPayment) return;

    setSplitAllocation((prev) => {
      const familySupport = Number(prev.familySupport || 0);
      const employerSupport = Number(prev.employerSupport || 0);
      const donorVoucher = Number(prev.donorVoucher || 0);
      const insuranceCoverage = expectedCoverageAmount;
      const remainingAfterInsurance = Math.max(0, amountValue - insuranceCoverage);
      const walletBalance = Math.max(0, remainingAfterInsurance - familySupport - employerSupport - donorVoucher);

      return {
        ...prev,
        walletBalance: walletBalance > 0 || amountValue > 0 ? walletBalance.toFixed(2) : "",
        insuranceCoverage: insuranceCoverage > 0 ? insuranceCoverage.toFixed(2) : "",
      };
    });
  }, [useSplitPayment, amountValue, expectedCoverageAmount]);


  const handlePayProvider = async () => {
  if (!isFormValid) return;

  setIsLoading(true);

  try {
    const payload = {
      providerId: selectedProvider?._id,
      amount: amountValue,
      serviceCategory,
      serviceDetails,
      dependentId: selectedDependentId || null,
      split: useSplitPayment
        ? numericSplit
        : {
            walletBalance: walletRequiredAfterCoverage,
            familySupport: 0,
            employerSupport: 0,
            donorVoucher: 0,
            insuranceCoverage: expectedCoverageAmount,
          },
    };

    await Services.wallet.payApprovedService(payload);

    alert(
      `Payment of $${amountValue.toFixed(2)} made to ${selectedProvider.name}`
    );

    setPayAmount("");
    setSelectedProvider(null);
    setServiceDetails("");
    setSelectedDependentId("");
    setUseSplitPayment(false);
    setSplitAllocation({
      walletBalance: "",
      familySupport: "",
      employerSupport: "",
      donorVoucher: "",
      insuranceCoverage: "",
    });
    setCoveragePreview(null);
    fetchDashboardData();
  } catch (error) {
    alert(error?.response?.data?.error || error?.message || "Payment failed.");
  } finally {
    setIsLoading(false);
  }
};


  
  // Open QR scanner
  const handleScanQRCode = () => {
    setScanning(true);
  };

  // Start QR scanner
  useEffect(() => {
    if (!scanning) return;

    const html5QrCode = new Html5Qrcode("qr-reader");
    const config = { fps: 10, qrbox: 250 };

    html5QrCode
      .start(
        { facingMode: "environment" },
        config,
        (decodedText) => {
          html5QrCode.stop();
          setScanning(false);
          if (decodedText.startsWith("http")) {
            window.location.href = decodedText;
          } else {
            navigate(decodedText);
          }
        },
        (errorMessage) => {
          // optionally handle scan errors
        }
      )
      .catch((err) => {
        console.error("Unable to start QR scanner", err);
        setScanning(false);
        alert("Failed to start scanner. Please try again.");
      });

    return () => {
      html5QrCode.stop().catch(() => {});
    };
  }, [scanning]);

  return (
    <div style={{ maxWidth: 420, margin: "0 auto", padding: 16 }}>
      {/* Back Arrow for navigation */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 18 }}>
        <i
          className="fi fi-br-angle-left"
            onClick={() => setActiveScreen("Dashboard")}
          style={{
            fontSize: 28,
            color: "#704af6",
            cursor: "pointer",
            marginRight: 10,
            ...((typeof styles !== 'undefined' && styles.backArrow) ? styles.backArrow : {})
          }}
          aria-label="Back"
        />
        <span style={{ fontWeight: 700, fontSize: 20, color: "#222" }}>Pay Provider</span>
      </div>

      {coveragePreview?.covered && (
        <Card style={{ marginBottom: 16, background: "linear-gradient(135deg, rgba(112,74,246,0.08), rgba(25,195,125,0.08))" }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Insurance coverage available</div>
          <div style={{ color: "#5b6472", fontSize: 14 }}>
            {coveragePreview.coveragePercentage}% of this service is covered. Your wallet only needs to cover ${walletRequiredAfterCoverage.toFixed(2)}.
          </div>
        </Card>
      )}

      {!useSplitPayment && amountValue > 0 && !coveragePreview?.covered && amountValue > walletBalance && (
        <Card style={{ marginBottom: 16, background: "rgba(255, 193, 7, 0.12)" }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Wallet balance is low</div>
          <div style={{ color: "#5b6472", fontSize: 14 }}>
            Add funds or switch to split payment if another source will help cover this service.
          </div>
        </Card>
      )}

    {/* QR Pay - SAME LOGIC */}
    <Card
      onClick={handleScanQRCode}
      style={{
        background: "linear-gradient(135deg, #6D5EF6, #8B7BFF)",
        color: "#fff",
        cursor: "pointer",
      }}
    >
      <div style={{ textAlign: "center", padding: "14px 0" }}>
        <QrCode size={34} />
        <div style={{ fontWeight: 600, marginTop: 8 }}>
          Scan QR Code to Pay
        </div>
        <div style={{ fontSize: 13, opacity: 0.9, marginTop: 4 }}>
          Pay a verified healthcare provider instantly
        </div>
      </div>
    </Card>

    {/* QR Scanner Overlay - UNCHANGED LOGIC */}
    {scanning && (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.85)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            padding: 16,
            width: "90%",
            maxWidth: 360,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontWeight: 600,
              marginBottom: 12,
            }}
          >
            Scan Provider QR Code
          </div>

          <div id="qr-reader" style={{ width: "100%" }} />
        </div>

        <button
          onClick={() => setScanning(false)}
          style={{
            marginTop: 20,
            background: "#fff",
            padding: "10px 18px",
            borderRadius: 12,
            border: "none",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    )}

    {/* Provider Categories - same data */}
<Card>
  <div style={sectionTitle}>Choose Healthcare Provider</div>

  {providerList.map((item) => {
    const isSelected = selectedProvider?._id === item._id;

    return (
      <div
        key={item._id}
        onClick={() => setSelectedProvider(item)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          padding: "12px",
          border: isSelected
            ? "2px solid #6D5EF6"
            : "1px solid #eee",
          background: isSelected ? "#F4F2FF" : "#fff",
          borderRadius: "10px",
          marginBottom: "10px",
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img
            src={item.logo}
            alt={item.name}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              objectFit: "cover"
            }}
          />

          <div>
            <div style={{ fontWeight: 600 }}>{item.name}</div>
            <div style={{ fontSize: 12, color: "#666" }}>
              {item.phone}
            </div>
            <div
              style={{
                fontSize: 12,
                color: item.verified ? "green" : "red"
              }}
            >
              {item.verified ? "Verified" : "Not Verified"}
            </div>
          </div>
        </div>

        {isSelected && (
          <CheckCircle color="#6D5EF6" size={22} />
        )}
      </div>
    );
  })}
</Card>


    {/* Payment Details */}
    {selectedProvider && (
      <Card>
        <div style={sectionTitle}>Payment Details</div>

        <select
          value={serviceCategory}
          onChange={(e) => setServiceCategory(e.target.value)}
          style={inputStyle}
        >
          {approvedCategories.map((category) => (
            <option key={category.value} value={category.value}>
              {category.label}
            </option>
          ))}
        </select>

        <select
          value={selectedDependentId}
          onChange={(e) => setSelectedDependentId(e.target.value)}
          style={inputStyle}
        >
          <option value="">Pay for myself</option>
          {dependents.map((dependent) => (
            <option key={dependent._id} value={dependent._id}>
              {dependent.fullName} ({dependent.relationship})
            </option>
          ))}
        </select>

        <input
          placeholder="Service (e.g. Consultation, Lab Test)"
          value={serviceDetails}
          onChange={(e) => setServiceDetails(e.target.value)}
          style={inputStyle}
        />

        <div style={{ position: "relative", marginTop: 16 }}>
          <span style={currencyPrefix}>$</span>
          <input
            type="number"
            placeholder="0.00"
            value={payAmount}
            onChange={(e) => setPayAmount(e.target.value)}
            style={{ ...inputStyle, paddingLeft: 40 }}
          />
        </div>

        <div style={{ marginTop: 14, padding: 10, borderRadius: 10, background: "#F8F7FB" }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 600, fontSize: 13 }}>
            <input
              type="checkbox"
              checked={useSplitPayment}
              onChange={(e) => setUseSplitPayment(e.target.checked)}
            />
            Use split payment (wallet/family/employer/donor/insurance)
          </label>

          {useSplitPayment && (
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              {[
                ["walletBalance", "Wallet"],
                ["familySupport", "Family"],
                ["employerSupport", "Employer"],
                ["donorVoucher", "Donor"],
                ["insuranceCoverage", "Insurance"],
              ].map(([key, label]) => (
                <div key={key}>
                  <div style={{ fontSize: 11, color: "#6B6781", marginBottom: 4 }}>{label}</div>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={splitAllocation[key]}
                    onChange={(e) => setSplitAllocation((prev) => ({ ...prev, [key]: e.target.value }))}
                    placeholder="0.00"
                    style={{ ...inputStyle, marginTop: 0, fontSize: 13 }}
                  />
                </div>
              ))}
              <div style={{ gridColumn: "1 / span 2", fontSize: 12, color: isSplitValid ? "#0D9B59" : "#B91C1C", fontWeight: 600 }}>
                Split total: ${splitTotal.toFixed(2)} / ${amountValue.toFixed(2)}
              </div>
            </div>
          )}
        </div>

      <Button
  onClick={handlePayProvider}
  loading={isLoading}
  disabled={!isFormValid}
  style={{
    width: "100%",
    marginTop: 20,
    background: isFormValid
      ? "linear-gradient(135deg, #6D5EF6, #8B7BFF)"
      : "#ccc",
    cursor: isFormValid ? "pointer" : "not-allowed"
  }}
>
  Pay {selectedProvider?.name}
</Button>

      </Card>
    )}
  </div>
);

};



  // ------------------ INSURANCE SCREENS ------------------
  const ManagePlan = () => {
    const [selectedPlan, setSelectedPlan] = useState(null);

    return (
      <div style={{ maxWidth: "540px", margin: "0 auto", padding: "32px 0 48px 0" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
          <button
             onClick={() => setActiveScreen("Dashboard")}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              marginRight: 8,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              width: 36,
              height: 36,
              boxShadow: '0 1px 4px rgba(112,74,246,0.10)'
            }}
            aria-label="Back"
          >
            <i className="fi fi-br-angle-left"  style={{ fontSize: 22, color: '#704af6', fontWeight: 700 }} />
          </button>
          <h2 style={{ fontWeight: 800, fontSize: 22, color: '#222', margin: 0 }}>Manage Insurance</h2>
        </div>

        {insuranceSubscription ? (
          <Card style={{
            background: '#fff',
            borderRadius: 24,
            boxShadow: '0 8px 32px rgba(112,74,246,0.10)',
            margin: '32px 0 24px 0',
            border: 'none',
          }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <Shield size={32} color="#704af6" />
              <div style={{ marginLeft: "16px" }}>
                <div style={{ fontWeight: 800, fontSize: "1.25rem", color: "#704af6", letterSpacing: '-0.5px' }}>
                  {insuranceSubscription.plan?.name || "Current Plan"}
                </div>
                <div style={{ fontSize: "1rem", color: "#6B7280" }}>
                  Active • Renews {new Date(insuranceSubscription.endDate).toLocaleDateString()}
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div style={{ fontWeight: 700, color: "#704af6", marginBottom: "12px", fontSize: 15 }}>Current Coverage</div>
              <div style={{ padding: "12px", background: "rgba(112, 74, 246, 0.07)", borderRadius: "16px" }}>
                {insuranceSubscription.plan?.coverageDetails?.map((coverage, i) => (
                  <div key={i} style={{ marginBottom: "10px", padding: "10px", background: "#f7f7fb", borderRadius: "10px" }}>
                    <div style={{ fontWeight: 700, color: "#2D3436" }}>{coverage.serviceType}</div>
                    <div style={{ fontSize: "0.95rem", color: "#6B7280" }}>
                      Coverage: <span style={{color:'#704af6', fontWeight:600}}>{coverage.coveragePercentage}%</span> up to <span style={{color:'#704af6', fontWeight:600}}>${coverage.limit}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{
                marginBottom: "20px",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #E5E2EF",
                background: "#FCFBFF",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                <div>
                  <div style={{ fontWeight: 700, color: "#2F2B46", fontSize: 14 }}>Auto-renew plan</div>
                  <div style={{ fontSize: 12, color: "#6B6781", marginTop: 2 }}>
                    {insuranceSubscription.autoRenew
                      ? "Your renewal will be processed automatically."
                      : "Manual renewal required before expiry."}
                  </div>
                </div>

                <button
                  onClick={() => handleUpdateSubscriptionSettings({ autoRenew: !insuranceSubscription.autoRenew })}
                  disabled={isLoading}
                  style={{
                    border: "none",
                    borderRadius: 999,
                    width: 62,
                    height: 34,
                    cursor: isLoading ? "not-allowed" : "pointer",
                    background: insuranceSubscription.autoRenew ? "#704af6" : "#D1D5DB",
                    position: "relative",
                    transition: "all 0.2s ease",
                  }}
                  aria-label="Toggle auto renew"
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 4,
                      left: insuranceSubscription.autoRenew ? 32 : 4,
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      background: "#fff",
                      transition: "left 0.2s ease",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                    }}
                  />
                </button>
              </div>

              {subscriptionUpdateNotice?.message && (
                <div
                  style={{
                    marginTop: 10,
                    borderRadius: 10,
                    padding: "8px 10px",
                    fontSize: 12.5,
                    fontWeight: 600,
                    background: subscriptionUpdateNotice.type === "success" ? "#ECFDF3" : "#FEF2F2",
                    color: subscriptionUpdateNotice.type === "success" ? "#065F46" : "#991B1B",
                    border: subscriptionUpdateNotice.type === "success" ? "1px solid #A7F3D0" : "1px solid #FECACA",
                  }}
                >
                  {subscriptionUpdateNotice.message}
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "12px" }}>
              <Button
                onClick={() => setActiveScreen("ViewCoverage")}
                style={{ flex: 1, background: 'linear-gradient(90deg, #704af6 0%, #8F6BFF 100%)', color: '#fff', fontWeight: 700, border: 'none', borderRadius: 12 }}
                loading={isLoading}
              >
                View Coverage
              </Button>
              <Button
                type="secondary"
                onClick={handleCancelSubscription}
                style={{ flex: 1, background: '#f7f7fb', color: '#704af6', fontWeight: 700, border: 'none', borderRadius: 12 }}
                loading={isLoading}
              >
                Cancel Plan
              </Button>
            </div>
          </Card>
        ) : (
          <Card style={{
            background: '#fff',
            borderRadius: 24,
            boxShadow: '0 8px 32px rgba(112,74,246,0.10)',
            margin: '32px 0 24px 0',
            border: 'none',
          }}>
            <div style={{ textAlign: "center", padding: "32px 0" }}>
              <Shield size={48} color="#704af6" style={{ marginBottom: "16px" }} />
              <div style={{ fontWeight: 700, fontSize: "1.2rem", color: "#704af6", marginBottom: "8px" }}>
                No Active Insurance
              </div>
              <div style={{ color: "#6B7280", marginBottom: "24px" }}>
                Subscribe to a plan to get healthcare coverage
              </div>
            </div>
          </Card>
        )}

        <Card style={{
          background: '#fff',
          borderRadius: 24,
          boxShadow: '0 8px 32px rgba(112,74,246,0.10)',
          margin: '0 0 24px 0',
          border: 'none',
        }}>
          <div style={{ fontWeight: 700, color: "#704af6", marginBottom: "12px", fontSize: 15 }}>Available Plans</div>
          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {insurancePlans.map((plan) => (
              <div
                key={plan._id}
                style={{
                  padding: "18px",
                  borderRadius: "16px",
                  border: `2px solid ${selectedPlan?._id === plan._id ? "#704af6" : "#E9ECEF"}`,
                  background: selectedPlan?._id === plan._id ? "rgba(112, 74, 246, 0.07)" : "#fff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  boxShadow: selectedPlan?._id === plan._id ? '0 2px 8px rgba(112,74,246,0.08)' : 'none',
                }}
                onClick={() => setSelectedPlan(plan)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <div style={{ fontWeight: 700, color: "#704af6" }}>{plan.name}</div>
                  <div style={{ fontWeight: 800, color: "#704af6", fontSize: 16 }}>${plan.monthlyPremium}/month</div>
                </div>
                <div style={{ color: "#6B7280", fontSize: "0.98rem", marginBottom: "8px" }}>
                  {plan.description}
                </div>
                <div style={{ fontSize: "0.95rem", color: "#704af6", fontWeight: 600 }}>
                  Coverage: ${plan.coverageLimit}
                </div>
              </div>
            ))}
          </div>
        </Card>

        {selectedPlan && !insuranceSubscription && (
          <Button
            type="primary"
            onClick={() => handleInsuranceSubscribe(selectedPlan._id)}
            style={{ width: "100%", marginTop: "16px", background: 'linear-gradient(90deg, #704af6 0%, #8F6BFF 100%)', color: '#fff', fontWeight: 700, border: 'none', borderRadius: 16, fontSize: 17, boxShadow: '0 4px 16px rgba(112,74,246,0.13)' }}
            loading={isLoading}
          >
            Subscribe for ${selectedPlan.monthlyPremium}/month
          </Button>
        )}
      </div>
    );
  };

  const ViewCoverage = () => (
    <div style={{ maxWidth: 420, margin: "0 auto", padding: 16 }}>
      {/* Back Arrow for Insurance Claim */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 18 }}>
        <i
          className="fi fi-br-angle-left"
          onClick={() => setActiveScreen("Dashboard")}
          style={{
            fontSize: 28,
            color: "#704af6",
            cursor: "pointer",
            marginRight: 10,
            ...((typeof styles !== 'undefined' && styles.backArrow) ? styles.backArrow : {})
          }}
          aria-label="Back"
        />
        <span style={{ fontWeight: 700, fontSize: 20, color: "#222" }}>Coverage Details</span>
      </div>

  {insuranceSubscription ? (
    <>
      {/* Plan Summary */}
      <Card>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Shield size={28} color="#6D5EF6" />
          <div>
            <div style={{ fontWeight: 700 }}>
              {insuranceSubscription.plan?.name}
            </div>
            <div style={{ fontSize: 13, color: "#6B7280" }}>
              Active • Renews{" "}
              {new Date(
                insuranceSubscription.endDate
              ).toLocaleDateString()}
            </div>
          </div>
        </div>
      </Card>

      {/* Coverage Grid */}
      <Card>
        <div style={sectionTitle}>Covered Services</div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 12,
          }}
        >
          {insuranceSubscription.plan?.coverageDetails?.map(
            (coverage, index) => (
              <div
                key={index}
                style={{
                  background: "#F6F7FB",
                  borderRadius: 14,
                  padding: 14,
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 22, marginBottom: 6 }}>
                  {getServiceIcon(coverage.serviceType)}
                </div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>
                  {coverage.serviceType
                    .replace("_", " ")
                    .toUpperCase()}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#6D5EF6",
                    marginTop: 4,
                  }}
                >
                  {coverage.coveragePercentage}% up to $
                  {coverage.limit}
                </div>
              </div>
            )
          )}
        </div>
      </Card>

      {/* Claims */}
      <Card>
        <div style={sectionTitle}>Recent Claims</div>

        {insuranceClaims.length > 0 ? (
          insuranceClaims.map((claim) => (
            <div
              key={claim._id}
              style={{
                padding: 12,
                borderRadius: 12,
                background: "#F7F7FB",
                marginBottom: 10,
              }}
            >
              <div style={{ fontWeight: 600 }}>
                {claim.type.replace("_", " ")}
              </div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>
                {new Date(claim.createdAt).toLocaleDateString()}
              </div>
              <div style={{ fontWeight: 700, marginTop: 6 }}>
                ${claim.amount.toFixed(2)}
              </div>
            </div>
          ))
        ) : (
          <div style={emptyText}>No claims submitted yet</div>
        )}
      </Card>
    </>
  ) : (
    <Card>
      <div style={{ textAlign: "center", padding: 24 }}>
        <Shield size={40} color="#9CA3AF" />
        <div style={{ fontWeight: 600, marginTop: 12 }}>
          No Active Insurance
        </div>
        <Button
          style={{ marginTop: 16 }}
          onClick={() => setActiveScreen("ManagePlan")}
        >
          View Plans
        </Button>
      </div>
    </Card>
  )}
</div>

  );





  // Helper function for service icons
const getCareDescription = (tx) => {
  if (tx.description) return tx.description;

  switch (tx.type) {
    case "payment":
      return "Doctor visit";
    case "lab_payment":
      return "Lab test";
    case "pharmacy_payment":
      return "Pharmacy order";
    case "insurance_payment":
      return "Covered medical care";
    default:
      return "Medical service";
  }
};

const getCareStatus = (tx) => {
  if (tx.type === "insurance_payment") {
    return {
      label: "Covered",
      color: "#047857",
      background: "#ECFDF5",
    };
  }

  switch (tx.status) {
    case "completed":
      return {
        label: "Completed",
        color: "#4338CA",
        background: "#EEF2FF",
      };
    case "pending":
      return {
        label: "Pending results",
        color: "#B45309",
        background: "#FEF3C7",
      };
    default:
      return null;
  }
};

  const getServiceIcon = (serviceType) => {
    const icons = {
      outpatient: <Stethoscope size={20} color="#704af6" />,
      lab_test: <FlaskConical size={20} color="#704af6" />,
      teleconsult: <User size={20} color="#704af6" />,
      medication: <Pill size={20} color="#704af6" />,
      emergency_transport: <Ambulance size={20} color="#704af6" />,
      remote_monitoring: <TrendingUp size={20} color="#704af6" />,
      health_records: <FileText size={20} color="#704af6" />,
      insurance_premium: <Shield size={20} color="#704af6" />,
      preventive_care: <CheckCircle size={20} color="#704af6" />,
      dental: <BoldIcon size={20} color="#704af6" />,
      vision: <Eye size={20} color="#704af6" />,
    };
    return icons[serviceType] || <Hospital size={20} color="#704af6" />;
  };




const ExternalTopup = () => {
  const handleCopy = () => {
    const link = `https://app.qureohealth.com/wallet-transfer/${userId}`; // replace with real wallet link
    navigator.clipboard.writeText(link);
    alert("Wallet transfer link copied to clipboard!");
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1a1a1a",
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
        <button
            onClick={() => setActiveScreen("Dashboard")}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            marginRight: 8,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            width: 36,
            height: 36,
            boxShadow: '0 1px 4px rgba(112,74,246,0.10)'
          }}
          aria-label="Back"
        >
          <i className="fi fi-br-angle-left" style={{ fontSize: 22, color: '#704af6', fontWeight: 700 }} />
        </button>
        <h2 style={{ fontWeight: 800, fontSize: 22, color: '#222', margin: 0 }}>Support a Family Member</h2>
      </div>

      <p
        style={{
          fontSize: "15px",
          color: "#555",
          marginBottom: "24px",
          lineHeight: "1.6",
        }}
      >
        Share your wallet info with family, friends, and loved ones to receive
        payments directly into your health wallet.
      </p>

      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          padding: "20px",
          marginBottom: "24px",
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "12px",
            color: "#222",
          }}
        >
          How does this feature work?
        </h3>

        <p style={{ color: "#555", fontSize: "15px", lineHeight: "1.6" }}>
          Users can now have their health wallet funded from external sources by
          copying and sharing their wallet transfer link with anyone who wants
          to deposit funds.
        </p>

        <ul
          style={{
            marginTop: "12px",
            paddingLeft: "20px",
            color: "#444",
            fontSize: "14.5px",
            lineHeight: "1.7",
          }}
        >
          <li>
             Money deposited using this method <b>cannot be withdrawn</b> from
            this account.
          </li>
          <li>
           Deposited funds can only be used for healthcare services such as
            booking lab tests, buying drugs, paying for consultations, and
            settling healthcare provider bills.
          </li>
        </ul>
      </div>

      <button
        onClick={handleCopy}
        style={{
          width: "100%",
          background: "var(--primary)",
          color: "#fff",
          border: "none",
          borderRadius: "12px",
          padding: "14px 0",
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.opacity = "0.9")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.opacity = "1")
        }
      >
        <Copy size={18} />
        Copy Wallet Transfer Link
      </button>
    </div>
  );
};

const ManageDependents = () => {
  const [fullName, setFullName] = useState("");
  const [relationship, setRelationship] = useState("child");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [linkedAccountEmail, setLinkedAccountEmail] = useState("");
  const [allowanceDependentId, setAllowanceDependentId] = useState("");
  const [allowanceAmount, setAllowanceAmount] = useState("");
  const [allowanceReference, setAllowanceReference] = useState("");
  const [allowanceCategories, setAllowanceCategories] = useState(["consultation", "medicine", "lab_test", "emergency_transport", "remote_monitoring", "health_records", "insurance_premium", "preventive_care"]);
  const [saving, setSaving] = useState(false);
  const [isFetchingDependents, setIsFetchingDependents] = useState(false);
  const [dependentsError, setDependentsError] = useState("");
  const [supportAllocations, setSupportAllocations] = useState([]);
  const [linkedDependents, setLinkedDependents] = useState([]);
  const [linkedDependentsError, setLinkedDependentsError] = useState("");
  const [isFetchingLinkedDependents, setIsFetchingLinkedDependents] = useState(false);

  const allowanceCategoryOptions = [
    { value: "consultation", label: "Doctor consultations (chat/audio/video/specialist)" },
    { value: "medicine", label: "Pharmacy (prescription, OTC, refills)" },
    { value: "lab_test", label: "Lab tests (home/workplace/lab visit)" },
    { value: "emergency_transport", label: "Emergency care (ambulance/urgent transport)" },
    { value: "remote_monitoring", label: "Remote monitoring (BP, glucose, vitals)" },
    { value: "health_records", label: "Health records (uploads/reports/docs fees)" },
    { value: "insurance_premium", label: "Insurance contributions (premium/co-pay)" },
    { value: "preventive_care", label: "Preventive care (screening/vaccination/wellness)" },
    { value: "follow_up", label: "Follow-up care" },
  ];

  const refreshDependents = async (options = {}) => {
    const { silent = false } = options;
    try {
      if (!silent) {
        setIsFetchingDependents(true);
        setIsFetchingLinkedDependents(true);
      }
      setDependentsError("");
      setLinkedDependentsError("");
      const [response, fundingContext, linkedResponse] = await Promise.all([
        Services.wallet.getDependents(),
        Services.wallet.getFundingContext(),
        Services.wallet.getLinkedDependents(),
      ]);
      setDependents(Array.isArray(response?.dependents) ? response.dependents : []);
      setSupportAllocations(Array.isArray(fundingContext?.context?.supportAllocations) ? fundingContext.context.supportAllocations : []);
      setLinkedDependents(Array.isArray(linkedResponse?.linkedDependents) ? linkedResponse.linkedDependents : []);
      hasLoadedDependentsRef.current = true;
    } catch (error) {
      setDependentsError(error?.response?.data?.error || error?.message || "Failed to load dependents.");
      setLinkedDependentsError(error?.response?.data?.error || error?.message || "Failed to load linked dependent access.");
      console.error("Failed to refresh dependents", error);
    } finally {
      if (!silent) {
        setIsFetchingDependents(false);
        setIsFetchingLinkedDependents(false);
      }
    }
  };

  useEffect(() => {
    if (!hasLoadedDependentsRef.current) {
      refreshDependents();
    }
  }, []);

  const handleAddDependent = async () => {
    if (!fullName.trim()) {
      alert("Please enter dependent name");
      return;
    }

    try {
      setSaving(true);
      await Services.wallet.addDependent({
        fullName,
        relationship,
        dateOfBirth: dateOfBirth || null,
        linkedAccountEmail: linkedAccountEmail || null,
      });
      setFullName("");
      setRelationship("child");
      setDateOfBirth("");
      setLinkedAccountEmail("");
      await refreshDependents({ silent: true });
      alert("Dependent added successfully.");
    } catch (error) {
      alert(error?.response?.data?.error || error?.message || "Failed to add dependent.");
    } finally {
      setSaving(false);
    }
  };

  const handleRemoveDependent = async (dependentId) => {
    try {
      await Services.wallet.removeDependent(dependentId);
      await refreshDependents({ silent: true });
      alert("Dependent removed.");
    } catch (error) {
      alert(error?.response?.data?.error || error?.message || "Failed to remove dependent.");
    }
  };

  const handleCreateAllowance = async () => {
    if (!allowanceDependentId) {
      alert("Select a dependent for this allowance.");
      return;
    }
    if (!allowanceAmount || Number(allowanceAmount) <= 0) {
      alert("Enter a valid allowance amount.");
      return;
    }
    if (allowanceCategories.length === 0) {
      alert("Select at least one allowed care category.");
      return;
    }

    try {
      setSaving(true);
      await Services.wallet.createDependentAllowance(allowanceDependentId, {
        amount: Number(allowanceAmount),
        reference: allowanceReference,
        allowedServiceCategories: allowanceCategories,
      });
      setAllowanceAmount("");
      setAllowanceReference("");
      setAllowanceDependentId("");
      setAllowanceCategories(["consultation", "medicine", "lab_test", "emergency_transport", "remote_monitoring", "health_records", "insurance_premium", "preventive_care"]);
      await refreshDependents({ silent: true });
      await fetchDashboardData();
      alert("Care allowance created.");
    } catch (error) {
      alert(error?.response?.data?.error || error?.message || "Failed to create allowance.");
    } finally {
      setSaving(false);
    }
  };

  const getDependentAllowance = (dependentId) =>
    supportAllocations.find((allocation) => String(allocation.dependentId) === String(dependentId));

  const selectedAllowanceDependent = dependents.find(
    (dependent) => String(dependent._id) === String(allowanceDependentId)
  );
  const isLinkedWalletTransfer = selectedAllowanceDependent?.linkedAccountStatus === "linked"
    && selectedAllowanceDependent?.careAccessMode === "linked_wallet";

  return (
    <div style={{ maxWidth: "500px", margin: "0 auto", padding: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24 }}>
        <button
          onClick={() => setActiveScreen("Dashboard")}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            marginRight: 8,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            width: 36,
            height: 36,
            boxShadow: "0 1px 4px rgba(112,74,246,0.10)",
          }}
          aria-label="Back"
        >
          <i className="fi fi-br-angle-left" style={{ fontSize: 22, color: "#704af6", fontWeight: 700 }} />
        </button>
        <h2 style={{ fontWeight: 800, fontSize: 22, color: "#222", margin: 0 }}>Manage Dependents</h2>
      </div>

      <Card>
        <div style={sectionTitle}>Add Dependent</div>
        <input
          placeholder="Full name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          style={inputStyle}
        />
        <select
          value={relationship}
          onChange={(e) => setRelationship(e.target.value)}
          style={{ ...inputStyle, marginTop: 10 }}
        >
          <option value="child">Child</option>
          <option value="parent">Parent</option>
          <option value="spouse_partner">Spouse / Partner</option>
          <option value="sibling">Sibling</option>
          <option value="domestic_worker_caregiver">Domestic worker / caregiver</option>
          <option value="elderly_family_member">Elderly family member</option>
          <option value="other_family_member">Other family member</option>
          <option value="other">Other</option>
        </select>
        <input
          type="date"
          value={dateOfBirth}
          onChange={(e) => setDateOfBirth(e.target.value)}
          style={{ ...inputStyle, marginTop: 10 }}
        />
        <input
          placeholder="Linked Qureo account email (optional)"
          value={linkedAccountEmail}
          onChange={(e) => setLinkedAccountEmail(e.target.value)}
          style={{ ...inputStyle, marginTop: 10 }}
        />
        <Button onClick={handleAddDependent} loading={saving} style={{ width: "100%", marginTop: 14, background : "var(--primary)" }}>
          Add Dependent
        </Button>
      </Card>

      <Card style={{ marginTop: 12 }}>
        <div style={sectionTitle}>{isLinkedWalletTransfer ? "Transfer to Linked Wallet" : "Create Care Allowance"}</div>
        <select
          value={allowanceDependentId}
          onChange={(e) => setAllowanceDependentId(e.target.value)}
          style={inputStyle}
        >
          <option value="">Select dependent</option>
          {dependents.map((dependent) => (
            <option key={dependent._id} value={dependent._id}>
              {dependent.fullName}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeholder="Allowance amount"
          value={allowanceAmount}
          onChange={(e) => setAllowanceAmount(e.target.value)}
          style={{ ...inputStyle, marginTop: 10 }}
        />
        <input
          placeholder="Allowance note or purpose"
          value={allowanceReference}
          onChange={(e) => setAllowanceReference(e.target.value)}
          style={{ ...inputStyle, marginTop: 10 }}
        />
        <div style={{ marginTop: 12, marginBottom: 6, fontWeight: 700, fontSize: 13, color: "#374151" }}>
          Allowed care uses
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 8,
          }}
        >
          {allowanceCategoryOptions.map((option) => {
            const checked = allowanceCategories.includes(option.value);
            return (
              <label
                key={option.value}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 10,
                  padding: "11px 12px",
                  width: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  borderRadius: 12,
                  background: checked ? "#F3EEFF" : "#F9FAFB",
                  border: checked ? "1px solid #BFA8FF" : "1px solid #E5E7EB",
                  fontSize: 12.5,
                  fontWeight: 600,
                  color: "#374151",
                  lineHeight: 1.35,
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  style={{ marginTop: 2, accentColor: "var(--primary)", width: 15, height: 15, flexShrink: 0 }}
                  onChange={(e) => {
                    setAllowanceCategories((prev) =>
                      e.target.checked
                        ? [...prev, option.value]
                        : prev.filter((category) => category !== option.value)
                    );
                  }}
                />
                <span style={{ flex: 1, minWidth: 0, overflowWrap: "anywhere" }}>{option.label}</span>
              </label>
            );
          })}
        </div>
        <Button onClick={handleCreateAllowance} loading={saving} style={{ width: "100%", marginTop: 14 }}>
          {isLinkedWalletTransfer ? "Transfer Funds" : "Create Allowance"}
        </Button>
      </Card>

      <Card style={{ marginTop: 12 }}>
        <div style={sectionTitle}>Your Dependents</div>
        {isFetchingDependents ? (
          <div style={emptyText}>Loading dependents...</div>
        ) : dependentsError ? (
          <div style={{ ...emptyText, color: "#B91C1C" }}>{dependentsError}</div>
        ) : dependents.length === 0 ? (
          <div style={emptyText}>No dependents added yet.</div>
        ) : (
          dependents.map((dependent) => (
            (() => {
              const allocation = getDependentAllowance(dependent._id);
              return (
            <div
              key={dependent._id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "12px 0",
                borderBottom: "1px solid #eee",
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>{dependent.fullName}</div>
                <div style={{ fontSize: 12, color: "#6B7280", textTransform: "capitalize" }}>
                  {dependent.relationship.replaceAll("_", " ")}
                </div>
                {dependent.linkedAccountEmail ? (
                  <div style={{ fontSize: 12, color: dependent.linkedAccountStatus === 'linked' ? '#047857' : '#B45309', marginTop: 4 }}>
                    {dependent.linkedAccountStatus === 'linked' ? `Linked to ${dependent.linkedAccountEmail}` : `Pending linked account: ${dependent.linkedAccountEmail}`}
                  </div>
                ) : null}
                {allocation ? (
                  <div style={{ marginTop: 8, fontSize: 12, color: '#4338CA' }}>
                    Allowance: ${Number(allocation.availableAmount || 0).toFixed(2)}
                    <div style={{ color: '#6B7280', marginTop: 4 }}>
                      Uses: {(allocation.allowedServiceCategories || []).join(', ').replaceAll('_', ' ')}
                    </div>
                  </div>
                ) : (
                  <div style={{ marginTop: 8, fontSize: 12, color: '#9CA3AF' }}>
                    No care allowance created yet.
                  </div>
                )}
              </div>
              <button
                onClick={() => handleRemoveDependent(dependent._id)}
                style={{
                  border: "none",
                  background: "#FEE2E2",
                  color: "#B91C1C",
                  borderRadius: 8,
                  padding: "6px 10px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Remove
              </button>
            </div>
              );
            })()
          ))
        )}
      </Card>

      <Card style={{ marginTop: 12 }}>
        <div style={sectionTitle}>Where You Are A Dependent</div>
        {isFetchingLinkedDependents ? (
          <div style={emptyText}>Loading linked accounts...</div>
        ) : linkedDependentsError ? (
          <div style={{ ...emptyText, color: "#B91C1C" }}>{linkedDependentsError}</div>
        ) : linkedDependents.length === 0 ? (
          <div style={emptyText}>No one has linked your account as a dependent yet.</div>
        ) : (
          linkedDependents.map((entry) => (
            <div
              key={entry._id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "12px 0",
                borderBottom: "1px solid #eee",
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>
                  Sponsor: {entry.owner?.fullName || "Unknown user"}
                </div>
                {entry.owner?.email ? (
                  <div style={{ fontSize: 12, color: "#6B7280" }}>
                    {entry.owner.email}
                  </div>
                ) : null}
                <div style={{ fontSize: 12, color: "#6B7280", textTransform: "capitalize", marginTop: 4 }}>
                  Relationship: {String(entry.relationship || "other").replaceAll("_", " ")}
                </div>
                {entry.allowance ? (
                  <div style={{ marginTop: 8, fontSize: 12, color: "#4338CA" }}>
                    Available care allowance: ${Number(entry.allowance.availableAmount || 0).toFixed(2)}
                    {(entry.allowance.allowedServiceCategories || []).length > 0 ? (
                      <div style={{ color: "#6B7280", marginTop: 4 }}>
                        Uses: {(entry.allowance.allowedServiceCategories || []).join(", ").replaceAll("_", " ")}
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div style={{ marginTop: 8, fontSize: 12, color: "#9CA3AF" }}>
                    No care allowance assigned yet.
                  </div>
                )}
              </div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  borderRadius: 999,
                  padding: "4px 9px",
                  background: entry.linkedAccountStatus === "linked" ? "#DCFCE7" : "#FEF3C7",
                  color: entry.linkedAccountStatus === "linked" ? "#047857" : "#B45309",
                  textTransform: "capitalize",
                }}
              >
                {entry.linkedAccountStatus || "linked"}
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
};



  // ------------------ SCREEN SWITCHER ------------------
  const screens = { 
    Dashboard, 
    AddMoney, 
    Withdraw, 
    PayProvider: PayProviderScreen, 
    ManagePlan, 
    ViewCoverage,
    ExternalTopup,
    ManageDependents,
  };
  const renderScreen = () => React.createElement(screens[activeScreen]);

  return (
    <div style={{ 
  background: "var(--bg)", 
  minHeight: "100vh", 
  padding: "5px",
  paddingBottom: "80px", // ≡ƒæê Add this to prevent overlap (adjust if needed)
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
}}>
  {isLoading && activeScreen === "Dashboard" && (
    <></>
  )}

  {/* Main screen content */}
  <div style={{ marginBottom: "20px" }}>
    {renderScreen()}
  </div>

  {/* Promo Banner */}
  <div style={{
    width: "100%",
    maxWidth: 520,
    minHeight: 62,
    margin: "18px auto 0 auto",
    background: "#f3f0ff",
    borderRadius: 14,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px 10px 16px",
    boxShadow: "0 1.5px 7px rgba(106,77,246,0.07)",
    position: "relative"
  }}>
    <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", textAlign: "left" }}>
      <div style={{ fontWeight: 700, fontSize: 13.5, color: "#2d1d5a", marginBottom: 1, lineHeight: 1.18, textAlign: "left" }}>
        Stay protected. Stay healthy.
      </div>
      <br></br>
      <div style={{ fontSize: 11, color: "#6B6781", marginBottom: 7, lineHeight: 1.18, textAlign: "left" }}>
        Top up your wallet and never delay <br></br>the care you need.
      </div>
      <button
        onClick={() => setActiveScreen("AddMoney")}
        style={{
          background: "#704af6",
          color: "#fff",
          border: "none",
          borderRadius: 999,
          padding: "5px 14px 5px 10px",
          fontWeight: 700,
          fontSize: 12.5,
          display: "flex",
          alignItems: "center",
          gap: 6,
          boxShadow: "0 1.5px 6px rgba(106,77,246,0.10)",
          cursor: "pointer",
          minHeight: 28,
          textAlign: "left"
        }}
      >
        Add Funds Now
        <ChevronRight size={13} color="#fff" />
      </button>
    </div>
    <img
      src={require("../assets/icons/purse.png")}
      alt="Wallet Promo"
      style={{ width: 150, height: "auto", marginLeft: 10, flexShrink: 0, display: "block" }}
    />
  </div>

  {/* Bottom navigation */}



      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
          
        
        input[type=number] {
          -moz-appearance: textfield;
        }
        
        * {
          -webkit-tap-highlight-color: transparent;
        }
      `}</style>
      <BottomNavigation/>
    </div>
  );
}

const styles = {
  trustBadge: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
    marginLeft: 45,
    marginTop: -7
  },
  trustIcon: {
    fontSize: 14,
    color: "green"
  },
  trustText: {
    fontSize: "0.85em",
    left: "-10px",
    lineHeight: "1",
  },
   header: {
    background: "var(--bg)",
    color: "var(--on-bg)",
    position: "relative",
    width: "100%",
    overflow: "visible",
    borderBottomLeftRadius: 25,
    borderBottomRightRadius: 25,
    marginBottom: 20,
    padding: "18px 0 8px",
    fontFamily: "'Poppins', sans-serif",
  },
  headerTop: {
    display: "flex",
    marginTop: 0,
    justifyContent: "space-between",
    alignItems: "center",
  },
  backArrow: {
    cursor: 'pointer',
    flexShrink: 0,
    fontSize: 22,
    fontWeight: 700,
    color: "var(--primary)",
    marginTop: 4,
  },
  headerTitle: {
    margin: 0,
    fontWeight: 700,
    fontSize: 22,
    marginLeft: 12,
    color: "var(--on-bg)",
    letterSpacing: "0.3px",
    textAlign: "center",
    lineHeight: 1.15,
  },
  cartIcon: {
    position: "relative",
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    backdropFilter: "blur(10px)",
    transition: "all 0.2s",
  },
   quickActions: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 12,
  },
  actionCard: {
    textAlign: "center",
    border: "none",
    borderRadius: 12,
    padding: "10px 14px",
    flex: 1,
    backdropFilter: "blur(6px)",
    transition: "all 0.2s",
    cursor: "pointer",
    backgroundImage: `url(${nine})`,
     backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    
  },
  actionText: {
    marginTop: 6,
    color: "white",
    fontWeight: 500,
    fontSize: 13
  },
  cartBadge: {
    position: "absolute",
    top: 8,
    right: 10,
    width: 8,
    height: 8,
    background: "var(--primary)",
    borderRadius: "50%",
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
  },
  headerSubtitle: {
     fontSize: 12,
    marginTop: 4,
    marginLeft: 34,
    textAlign: "left",
  },
}
const sectionTitle = {
  fontWeight: 600,
  fontSize: 15,
  marginBottom: 12,
};

const inputStyle = {
  width: "100%",
  padding: 14,
  borderRadius: 12,
  border: "1px solid #E5E7EB",
  background: "#F9FAFB",
  fontSize: 14,
};

const currencyPrefix = {
  position: "absolute",
  left: 14,
  top: "50%",
  transform: "translateY(-50%)",
  fontWeight: 700,
  color: "#6D5EF6",
};

const emptyText = {
  textAlign: "center",
  padding: 16,
  fontSize: 13,
  color: "#6B7280",
};
